// Translation dictionary for all supported languages
const translations = {
  en: {
    // SEO Meta Content
    seoTitle: "Premium Connector Alternatives - Save 50-70% on Quality Connectors",
    seoDescription: "Leading manufacturer of high-quality connector alternatives. Direct replacements for TE, Molex, Amphenol, JST at 50-70% cost savings. ISO certified, same quality standards.",
    seoKeywords: "connector alternatives, TE connector alternative, Molex alternative, Amphenol alternative, automotive connectors, industrial connectors, cost savings, quality connectors",
    seoFaqQ1: "How much can I save on connector alternatives?",
    seoFaqA1: "Our customers typically save 50-70% compared to major brands like TE, Molex, and Amphenol while maintaining the same quality standards.",
    seoFaqQ2: "Are your connectors compatible with major brands?",
    seoFaqA2: "Yes, our connectors are direct replacements for over 20 major brands including TE, Molex, Amphenol, JST, and more.",
    seoFaqQ3: "What industries do you serve?",
    seoFaqA3: "We serve automotive, industrial, medical, consumer electronics, and telecommunications industries with certified connector solutions.",
    
    // Navigation
    home: "Home",
    about: "About",
    services: "Services",
    products: "Products",
    industries: "Industries",
    manufacturing: "Manufacturing",
    blog: "Blog",
    contact: "Contact",
    admin: "Admin",
    
    // Hero Section
    premiumConnectorAlternatives: "Save 50–70% on Premium Connector Alternatives",
    qualitySolutions: "ISO-certified alternatives to TE, Molex, Amphenol, JST and 20+ major brands. Same specs. Fraction of the cost. Trusted by 1,000+ engineers in 8+ countries.",
    getAQuote: "Get a Quote",
    viewProducts: "View Products",
    directReplacements: "Direct replacements for 20+ major brands",
    notYourBrand: "Don't see your brand listed? We offer custom solutions for any connector brand.",
    
    // Cost Comparison
    savePercentage: "Save 50-70% Without Compromising Quality",
    sameSpecifications: "Same specifications, same performance, significantly lower cost",
    originalBrand: "Original Brand",
    qingshunAlternative: "Qingshun Alternative",
    whyCostLess: "Why Our Alternatives Cost Less",
    verticalIntegration: "Vertical Integration",
    directSales: "Direct Sales Model",
    efficientManufacturing: "Efficient Manufacturing",
    noPremiumMarkup: "No Premium Markup",
    costSavings: "Cost Savings",
    seeOurProducts: "See Our Products",
    competitivePricing: "Our competitive pricing comes from efficient processes and direct sales",
    significantSavings: "Significant Cost Savings",
    costSavingsDesc: "Experience 50-70% savings without compromising on quality or performance",
    verticalIntegrationDesc: "Control over the entire production chain reduces costs",
    efficientManufacturingDesc: "Modern automation and optimized processes",
    directSalesDesc: "Eliminating middlemen passes savings to you",
    noPremiumMarkupDesc: "No brand premium or licensing fees",
    
    // Stats
    yearsExperience: "Years Experience",
    globalClients: "Global Clients",
    countriesServed: "Countries Served",
    costSavingsStats: "Cost Savings",
    
    // Brand Replacement
    replacingBrands: "Replacing Major Brands",
    alternativesPremium: "Direct alternatives to premium connector brands with significant cost savings",
    cantFindBrand: "Can't find your brand?",
    alternativesAnyBrand: "We can create alternatives for virtually any connector brand. Contact us with your part number for a custom quote.",
    requestCustom: "for custom solutions",
    
    // About Section
    yourTrustedPartner: "Your Trusted Connector Partner",
    companyDescription1: "Suzhou Qingshun Electronics Technology Co., Ltd. manufactures drop-in replacements for connectors from TE, Molex, Amphenol, JST, and 20+ other leading brands — at 50–70% lower cost. ISO 9001 certified since 2017, we deliver the same specifications and performance your designs require.",
    companyDescription2: "Founded in 2011 with a fully vertically integrated factory in Suzhou, China — covering injection molding, precision stamping, plating, and final assembly under one roof. This end-to-end control keeps quality high and margins razor-thin, so the savings go directly to you.",
    learnMore: "Learn More About Us",
    
    // CTA
    readyToSave: "Ready to Save 50-70% on Connectors?",
    freeQuote: "Contact us today for a free quote and discover how our premium alternatives can reduce your costs",
    getYourQuote: "Get Your Quote",
    ourServices: "Our Services",
    
    // Footer
    contactInfo: "Contact Information",
    factoryAddress: "2526 Huayuan Road, Zhangpu Town, Kunshan City, Suzhou, Jiangsu, China",
    phone: "Phone",
    wechat: "WeChat",
    whatsapp: "WhatsApp",
    email: "Email",
    quickLinks: "Quick Links",
    allRights: "All rights reserved.",
    exportMarkets: "Global Export",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    sitemap: "Sitemap",
    globalExport: "Global Export",
    worldwideShipping: "Worldwide shipping with local support",
    servingClients: "Serving clients across 8+ countries worldwide",
    worldwide: "Worldwide",
    
    // Contact Page
    contactUs: "Contact Us",
    getInTouch: "Get in touch with our team",
    sendMessage: "Send Message",
    yourName: "Your Name",
    yourEmail: "Your Email",
    subject: "Subject",
    message: "Message",
    send: "Send",
    
    // Products Page
    ourProducts: "Our Products",
    highQualityAlternatives: "High-quality connector alternatives for diverse applications",
    automotiveConnectors: "Automotive Connectors",
    automotiveDesc: "High-reliability connectors for vehicle systems",
    medicalConnectors: "Medical Connectors",
    medicalDesc: "Precision connectors for healthcare equipment",
    industrialConnectors: "Industrial Connectors",
    industrialDesc: "Robust connectors for harsh environments",
    consumerElectronics: "Consumer Electronics",
    consumerDesc: "Miniature connectors for portable devices",
    dataServer: "Data & Server",
    dataDesc: "High-speed connectors for data centers",
    energyStorage: "Energy Storage",
    energyDesc: "Connectors for battery systems",
    brandsWeReplace: "Brands We Replace",
    costEffective: "Cost-effective alternatives to premium connector brands - Save 50-70% without compromising quality",
    needSpecific: "Need a Specific Brand Alternative?",
    alternativesAny: "We can create alternatives for virtually any connector brand. Contact us with your part number for a custom quote.",
    requestCustomAlternative: "Request Custom Alternative",
    productResources: "Product Resources",
    downloadTechnical: "Download technical documentation and specifications",
    catalog: "Catalog",
    comprehensiveCatalog: "Comprehensive product catalog with specifications and dimensions",
    downloadPDF: "Download PDF",
    datasheets: "Datasheets",
    technicalDatasheets: "Technical datasheets for all our connector series",
    needHelp: "Need Help Choosing the Right Product?",
    technicalTeam: "Our technical team is ready to assist you with product selection and customization",
    contactTechnical: "Contact Technical Support",
    customSolutions: "Custom Solutions",
    
    // Products Page - Additional Keys
    boardToBoard: "Board-to-Board",
    highDensity: "High-density connectors for compact electronics",
    pitchRange: "0.5mm to 2.54mm pitch range",
    highSpeed: "High-speed data transmission support",
    lowProfile: "Low profile designs for space-constrained applications",
    dualRow: "Dual row configurations for increased circuit density",
    wireToBoard: "Wire-to-Board",
    reliableConnections: "Reliable connections between wires and PCBs",
    singleDouble: "Single and double row configurations",
    lockingMechanism: "Locking mechanisms for secure connections",
    multipleWires: "Multiple wire termination options",
    colorCoding: "Color coding for easy identification",
    wireToWire: "Wire-to-Wire",
    flexibleSolutions: "Flexible solutions for wire connections",
    crimpTerminal: "Crimp terminal connections",
    insulationDisplacement: "Insulation displacement technology",
    multipleCircuits: "Multiple circuits in single connectors",
    environmentalProtection: "Environmental protection ratings",
    usbConnectors: "USB Connectors",
    universalConnectivity: "Universal connectivity solutions",
    usbTypes: "USB Type-A, Type-B, Type-C variants",
    powerDelivery: "Power delivery up to 100W",
    reversibleDesign: "Reversible connector designs",
    rfCoaxial: "RF & Coaxial",
    highFrequency: "High-frequency signal transmission",
    impedanceControl: "Precision impedance control",
    lowInsertion: "Low insertion loss characteristics",
    excellentShielding: "Excellent electromagnetic shielding",
    multipleFrequencies: "Multiple frequency range support",
    automotive: "Automotive",
    harshEnvironment: "Connectors for harsh environments",
    vibrationResistant: "Vibration resistant designs",
    temperatureRange: "-40°C to +125°C operating range",
    sealedHousings: "Sealed housings for moisture protection",
    automotiveStandards: "Compliant with automotive standards",
    medical: "Medical",
    precisionReliability: "Precision and reliability for medical devices",
    biocompatible: "Biocompatible materials available",
    sterilizable: "Sterilizable connector designs",
    lowNoise: "Low noise performance",
    miniaturized: "Miniaturized form factors",
    industrial: "Industrial",
    ruggedDurable: "Rugged and durable solutions",
    highCurrent: "High current carrying capacity",
    ipRated: "IP-rated for dust and water protection",
    corrosionResistant: "Corrosion resistant materials",
    extendedTemperature: "Extended temperature range operation",
    dataCenter: "Data Center",
    highPerformance: "High-performance computing connectors",
    lowLatency: "Ultra-low latency transmission",
    powerEfficient: "Power-efficient designs",
    rackMountable: "Rack-mountable solutions",
    connector: "Connector",
    comprehensiveRange: "Comprehensive range of connector solutions",
    connectorProducts: "Connector Products",
    connectors: "Connectors",
    productsDescription: "Explore our comprehensive range of high-quality connector alternatives for various applications",
    
    // About Page
    aboutUs: "About Us",
    companyOverview: "Company Overview",
    established: "Established in 2011, Qingshun Electronics has grown to become a leading manufacturer of high-quality connector alternatives.",
    ourMission: "Our Mission",
    missionText: "To provide cost-effective, high-quality connector solutions that help our customers reduce costs without compromising performance.",
    ourVision: "Our Vision",
    visionText: "To be the global leader in connector alternatives, recognized for our innovation, quality, and customer service.",
    ourValues: "Our Values",
    value1: "Quality First - We never compromise on quality",
    value2: "Customer Focus - Your success is our success",
    value3: "Innovation - Constantly improving our products and processes",
    value4: "Integrity - Honest and transparent in all our dealings",
    facilities: "Our Facilities",
    facility1: "15,000 sq ft manufacturing facility",
    facility2: "Advanced injection molding equipment",
    facility3: "Precision stamping machines",
    facility4: "Automated assembly lines",
    certifications: "Certifications",
    certified: "We are certified to international standards for quality and environmental management.",
    iso9001: "ISO 9001:2015 Quality Management",
    iso14001: "ISO 14001:2015 Environmental Management",
    rohs: "RoHS Compliance",
    reach: "REACH Compliance",
    meetOurTeam: "Meet Our Team",
    tonyChen: "Tony Chen",
    tonyTitle: "Founder & CEO",
    tonyBio: "With over 15 years of experience in the electronics industry, Tony leads our company with vision and expertise.",
    sarahJohnson: "Sarah Johnson",
    sarahTitle: "Technical Director",
    sarahBio: "Sarah oversees our technical operations and product development with over 12 years of engineering experience.",
    michaelWong: "Michael Wong",
    michaelTitle: "Operations Manager",
    michaelBio: "Michael ensures our manufacturing processes run efficiently and meet the highest quality standards.",
    
    // Services Page
    ourServices: "Our Services",
    comprehensiveOfferings: "Comprehensive manufacturing services tailored to your needs",
    connectorReplacement: "Connector Replacement",
    replacementDesc: "Direct alternatives to premium connector brands with significant cost savings",
    customManufacturing: "Custom Manufacturing",
    customDesc: "Bespoke connector solutions designed and manufactured to your exact specifications",
    cableAssembly: "Cable Assembly",
    cableDesc: "Complete cable assembly services from design to production",
    qualityControl: "Quality Control",
    qualityDesc: "Rigorous testing and inspection processes to ensure product reliability",
    rapidPrototyping: "Rapid Prototyping",
    prototypeDesc: "Quick turnaround prototyping services to accelerate your product development",
    supplyChain: "Supply Chain Solutions",
    supplyDesc: "End-to-end supply chain management to optimize your procurement process",
    valueAdded: "Value-Added Services",
    valueAddedDesc: "Additional services including kitting, labeling, and packaging",
    process: "Our Process",
    consultation: "Consultation",
    consultationDesc: "We work with you to understand your requirements and objectives",
    design: "Design",
    designDesc: "Our engineers create detailed designs and specifications",
    prototyping: "Prototyping",
    prototypingDesc: "We build prototypes for testing and validation",
    production: "Production",
    productionDesc: "Full-scale production with strict quality control",
    delivery: "Delivery",
    deliveryDesc: "Timely delivery to your specifications",
    support: "Support",
    supportDesc: "Ongoing technical support and service",
    fastDelivery: "Fast Delivery",
    quickTurnaround: "Quick Turnaround",
    completeProduction: "Complete Production",
    customSolutions: "Custom Solutions",
    tailoredDesigns: "Tailored Designs",
    qualityGuarantee: "Quality Guarantee",
    testedProducts: "Tested Products",    
    // Industries Page
    industriesServed: "Industries Served",
    diverseApplications: "Serving diverse industries with specialized connector solutions",
    automotive: "Automotive",
    automotiveText: "Connectors for engine control, infotainment, safety systems, and EV applications",
    medical: "Medical",
    medicalText: "Precision connectors for diagnostic equipment, patient monitoring, and surgical instruments",
    industrial: "Industrial",
    industrialText: "Robust connectors for automation, robotics, and process control systems",
    consumer: "Consumer Electronics",
    consumerText: "Miniature connectors for smartphones, tablets, wearables, and smart home devices",
    dataCenters: "Data Centers",
    dataCentersText: "High-speed connectors for servers, storage arrays, and networking equipment",
    energy: "Energy & Utilities",
    energyText: "Connectors for solar systems, battery storage, and grid infrastructure",
    aerospace: "Aerospace & Defense",
    aerospaceText: "High-reliability connectors for avionics and defense applications",
    telecommunications: "Telecommunications",
    telecommunicationsText: "Connectors for base stations, fiber optic networks, and 5G infrastructure",
    whyChooseIndustries: "Why Choose Us for Your Industry",
    industryExpertise: "Industry Expertise",
    expertiseText: "Deep understanding of industry-specific requirements and standards",
    customizedSolutions: "Customized Solutions",
    customizedText: "Tailored products to meet unique application challenges",
    compliance: "Compliance",
    complianceText: "Adherence to industry standards and certifications",
    globalSupport: "Global Support",
    globalText: "Worldwide support and service for international clients",
    
    // Additional Industries Page Keys
    vehicleSystems: "Connectors for critical vehicle systems",
    engineControl: "Engine Control Units (ECUs)",
    infotainment: "Infotainment Systems",
    safetyADAS: "Safety & ADAS Systems",
    electricVehicle: "Electric Vehicle (EV) Systems",
    powertrain: "Powertrain Control Systems",
    automotiveApplications: "Engine management, infotainment, safety systems, EV battery management, and autonomous driving technologies",
    medicalDevices: "Medical Devices",
    highReliability: "High-reliability precision connectors",
    patientMonitoring: "Patient Monitoring Equipment",
    diagnosticEquipment: "Diagnostic Imaging Systems",
    surgicalInstruments: "Surgical & Minimally Invasive Instruments",
    imagingSystems: "MRI, CT, and Ultrasound Systems",
    laboratoryEquipment: "Laboratory Automation Equipment",
    medicalApplications: "Patient monitoring, diagnostic imaging, surgical instruments, lab automation, and telemedicine devices",
    industrialAutomation: "Industrial Automation",
    controlMonitoring: "Control & monitoring systems",
    plcSystems: "Programmable Logic Controllers (PLCs)",
    robotics: "Industrial Robotics",
    sensorsActuators: "Sensors & Actuators",
    industrialNetworking: "Industrial Networking",
    processControl: "Process Control Systems",
    industrialApplications: "Factory automation, robotics, process control, sensors, and industrial IoT applications",
    energyStorage: "Energy Storage",
    batteryManagement: "Battery management systems",
    batteryPacks: "Battery Pack Connectors",
    energyStorageCabinets: "Energy Storage Cabinets",
    powerDistribution: "Power Distribution Units",
    solarSystems: "Solar Panel Systems",
    upsSystems: "UPS & Backup Power Systems",
    energyApplications: "Solar installations, battery storage systems, grid infrastructure, and backup power solutions",
    aviationDefense: "Aviation & defense systems",
    avionics: "Avionics Systems",
    flightControl: "Flight Control Systems",
    communicationSystems: "Communication Systems",
    navigationEquipment: "Navigation Equipment",
    defenseElectronics: "Defense Electronics",
    aerospaceApplications: "Aircraft avionics, flight controls, navigation systems, satellite communications, and defense electronics",
    serverData: "Server & Data Center",
    dataCenters: "Data Center Infrastructure",
    serverSystems: "Server Systems",
    storageArrays: "Storage Arrays",
    networkingEquipment: "Networking Equipment",
    cloudInfrastructure: "Cloud Infrastructure",
    serverApplications: "High-performance computing, data storage, network infrastructure, and cloud computing platforms",
    communicationInfrastructure: "Communication infrastructure",
    fiveG: "5G Network Infrastructure",
    networkEquipment: "Network Equipment",
    fiberOptic: "Fiber Optic Connections",
    wirelessSystems: "Wireless Communication Systems",
    satelliteCommunications: "Satellite Communications",
    telecomApplications: "5G base stations, fiber optic networks, wireless infrastructure, and satellite communications",
    personalDevices: "Personal electronic devices",
    smartphones: "Smartphones",
    tablets: "Tablets",
    wearables: "Wearable Devices",
    smartHome: "Smart Home Devices",
    audioEquipment: "Audio Equipment",
    consumerApplications: "Mobile devices, tablets, wearables, smart home products, gaming consoles, and audio equipment",
    industriesDescription: "Explore how Qingshun Electronics provides specialized connector solutions across diverse industries including automotive, medical, industrial, energy, aerospace, data centers, telecommunications, and consumer electronics.",
    providingReliable: "Providing reliable, high-performance connector solutions tailored to the unique demands of each industry we serve.",
    keyApplications: "Key Applications",
    solutionsWeProvide: "Solutions We Provide",
    needSolutionsSpecificIndustry: "Need Solutions for a Specific Industry?",
    engineeringTeam: "Our engineering team is ready to design and manufacture custom connector solutions for your industry-specific requirements.",
    talkToExpert: "Talk to an Expert",
    industriesWeServe: "Industries We Serve",
    
    // Manufacturing Page
    manufacturingProcess: "Manufacturing Process",
    inHouseCapabilities: "Complete in-house manufacturing capabilities",
    injectionMolding: "Injection Molding",
    moldingDesc: "Advanced injection molding for connector housings with precision tolerances",
    stamping: "Stamping",
    stampingDesc: "High-precision stamping for connector terminals and contacts",
    plating: "Plating",
    platingDesc: "Surface finishing with gold, tin, and other specialized coatings",
    assembly: "Assembly",
    assemblyDesc: "Automated and manual assembly processes for complete connector solutions",
    testing: "Testing",
    testingDesc: "Comprehensive testing including electrical, mechanical, and environmental validation",
    qualityAssurance: "Quality Assurance",
    assuranceDesc: "Rigorous quality control throughout the entire manufacturing process",
    equipment: "Our Equipment",
    equipmentText: "State-of-the-art manufacturing equipment for precision and consistency",
    moldingMachine: "Injection Molding Machines",
    stampingPress: "Precision Stamping Presses",
    platingLine: "Automated Plating Lines",
    assemblyLine: "Automated Assembly Lines",
    testingEquipment: "Advanced Testing Equipment",
    environmentalChamber: "Environmental Test Chambers",
    productionCapacity: "Production Capacity",
    capacityText: "High-volume production capabilities to meet your demand",
    monthlyCapacity: "Monthly Production Capacity",
    qualityControlProcess: "Quality Control Process",
    controlProcess: "Our comprehensive quality control process ensures consistent product quality",
    incomingInspection: "Incoming Material Inspection",
    incomingText: "Thorough inspection of all raw materials and components",
    inProcess: "In-Process Quality Checks",
    inProcessText: "Continuous monitoring during manufacturing",
    finalTesting: "Final Product Testing",
    finalText: "Comprehensive testing of finished products",
    documentation: "Documentation & Traceability",
    documentationText: "Detailed records for full product traceability",
    
    // Blog Page
    ourBlog: "Our Blog",
    insights: "Insights on connector technology, manufacturing trends, and industry news",
    stayUpdated: "Stay Updated with Our Insights",
    subscribe: "Subscribe to our newsletter for the latest blog posts and industry news",
    yourEmail: "Your email address",
    subscribeButton: "Subscribe",
    
    // 404 Page
    pageNotFound: "Page Not Found",
    pageNotFoundText: "The page you're looking for doesn't exist or has been moved. Let's get you back on track.",
    quickNavigation: "Quick Navigation",
    returnHome: "Return Home",
    browseProducts: "Browse Products",
    needHelp404: "Need Help?",
    help404: "If you're having trouble finding what you're looking for, our team is here to help.",
    contactSupport: "Contact Support",
    callUs: "Call Us",
    errorReference: "Error code: 404 - Page not found",
    backToBusiness: "Back to business with Qingshun Electronics",
    goToPage: "Go to page",
    goBack: "Go Back",
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    didYouKnow: "Did You Know?",
    pageTip: "Try checking the URL for errors or use our navigation above.",
    trustedBy: "Trusted by 1000+ global clients since 2011",
    
    // Theme Toggle
    switchToLight: "Switch to light mode",
    switchToDark: "Switch to dark mode",
    
    // Contact Page
    needCustom: "Need a custom",
    connectorSolution: "connector solution",
    engineeringTeam: "Our engineering team is ready to design and manufacture custom connector solutions for your specific requirements.",
    requestQuote: "Request a Quote",
    viewAllServices: "View All Services",
    
    // Missing keys for Services page
    connectorManufacturing: "Connector Manufacturing",
    connectorManufacturingDesc: "Complete manufacturing services from design to production of custom connectors",
    customConnectorDesign: "Custom connector design and engineering",
    materialSelection: "Material selection and sourcing",
    precisionManufacturing: "Precision manufacturing with tight tolerances",
    qualityAssurance: "Comprehensive quality assurance testing",
    stampingServices: "Stamping Services",
    stampingServicesDesc: "High-precision stamping for connector terminals and contacts",
    progressiveDie: "Progressive die stamping for complex parts",
    materialPlating: "Material plating and surface finishing",
    tightTolerance: "Tight tolerance stamping capabilities",
    volumeProduction: "High-volume production runs",
    moldDevelopment: "Mold Development",
    moldDevelopmentDesc: "Custom mold design and development for connector housings",
    cadcadDesign: "CAD/CAE design and simulation",
    moldFlow: "Mold flow analysis and optimization",
    maintenanceRepair: "Mold maintenance and repair services",
    injectionMolding: "Injection Molding",
    injectionMoldingDesc: "Advanced injection molding for connector housings",
    multiCavity: "Multi-cavity mold production",
    materialEngineering: "Material engineering and selection",
    precisionTolerances: "Precision tolerances control",
    highVolume: "High-volume production capabilities",
    cableAssembly: "Cable Assembly",
    cableAssemblyDesc: "Complete cable assembly services from design to production",
    customWire: "Custom wire harness design",
    connectorAssembly: "Connector assembly and termination",
    testingValidation: "Testing and validation services",
    ulCertification: "UL and other certification support",
    qualityControlDesc: "Rigorous quality control throughout the manufacturing process",
    incomingInspection: "Incoming material inspection",
    inProcessControl: "In-process quality control",
    finalTesting: "Final product testing and validation",
    documentationCertification: "Documentation and certification support",
    tooling: "Tooling",
    toolingDesc: "Tool design and preparation for production",
    testingDesc: "Comprehensive testing and validation",
    servicesDescription: "Complete manufacturing services for custom connectors and cable assemblies with quality assurance",
    electronicsManufacturing: "Electronics Manufacturing",
    our: "Our",
    comprehensiveServices: "Comprehensive manufacturing services tailored to your needs",
    fromConcept: "From concept to completion, we ensure quality at every step",
    readyToStart: "Ready to start your",
    project: "project",
    contactUsDiscuss: "Contact us today to discuss your manufacturing requirements",
    getInTouch: "Get In Touch",
    
    // Missing keys for About page
    companyFounded: "Company Founded",
    establishedSuzhou: "Established in Suzhou, China as a specialized connector manufacturer",
    internationalExpansion: "International Expansion",
    firstExports: "First exports to European and North American markets",
    rohsCertification: "RoHS Certification",
    achievedCompliance: "Achieved RoHS compliance for environmental standards",
    thousandClients: "1,000+ Global Clients",
    reachedMilestone: "Reached milestone of serving 1,000+ global clients",
    advancedAutomation: "Advanced Automation",
    upgradedFacilities: "Upgraded facilities with advanced automation technology",
    globalLeader: "Global Leader",
    servingCountries: "Serving clients across 8+ countries worldwide",
    qualityFirst: "Quality First",
    qualityFirstDesc: "We never compromise on quality in any aspect of our operations",
    customerFocus: "Customer Focus",
    customerFocusDesc: "Your success is our success - we work closely with clients to meet their specific needs",
    innovation: "Innovation",
    innovationDesc: "Constantly improving our products and processes through innovation",
    globalReach: "Global Reach",
    globalReachDesc: "Serving clients across multiple countries with localized support",
    yearsInBusiness: "Years in Business",
    brandsReplaced: "Brands Replaced",
    annualProduction: "Annual Production",
    qualityTested: "Quality Tested",
    aboutDescription: "Learn about Qingshun Electronics, a leading manufacturer of high-quality connector alternatives and custom cable assemblies since 2011.",
    aboutPageDescription: "About Qingshun Electronics - Leading manufacturer of connector alternatives and custom cable assemblies",
    leadingManufacturer: "Leading manufacturer of high-quality connector alternatives and custom cable assemblies",
    whoWeAre: "Who We Are",
    weAre: "We Are",
    productsServe: "Our products serve diverse industries including automotive, medical, industrial, and consumer electronics with cost-effective solutions.",
    factoryImageAlt: "Qingshun Electronics manufacturing facility exterior",
    coreValues: "Core Values",
    principlesGuide: "The principles that guide our business operations and relationships",
    ourJourney: "Our Journey",
    journey: "Journey",
    keyMilestones: "Key milestones in our company's development and growth",
    quality: "Quality",
    certificationsQuality: "Certifications & Quality",
    committedStandards: "Committed to the highest standards of quality and compliance",
    
    // Missing keys for Contact page
    us: "Us",
    contactDescription: "Contact Qingshun Electronics for product quotes, custom manufacturing services, technical support, or partnership opportunities. We're ready to help with your connector needs.",
    generalInquiry: "General Inquiry",
    productQuote: "Product Quote Request",
    customManufacturing: "Custom Manufacturing",
    technicalSupport: "Technical Support",
    partnershipOpportunity: "Partnership Opportunity",
    other: "Other",
    messageSent: "Message Sent!",
    thankYouMessage: "Thank you for contacting us. We'll get back to you as soon as possible.",
    company: "Company",
    yourCompany: "Your Company Name",
    selectSubject: "Select a Subject",
    howCanWeHelp: "How can we help you?",
    attachment: "Attachment",
    optional: "Optional",
    chooseFile: "Choose File",
    maxFileSize: "Max file size: 10MB",
    companyInformation: "Company Information",
    address: "Address",
    businessHours: "Business Hours",
    businessHoursDetails: "Monday - Friday: 8:00 AM - 6:00 PM (GMT+8)",
    whyChooseQingshun: "Why Choose Qingshun",
    comparedToBrands: "compared to premium brands",
    certifiedManufacturing: "certified manufacturing",
    yearsOfExperience: "years of experience",
    globalExport: "Global export capabilities",
    contactToday: "Contact us today for a free quote!",
    
    // Missing keys from Home.js
    comprehensiveSolutions: "Comprehensive solutions for your connector needs",
    aboutOurCompany: "About Our Company",
    isoCertified: "ISO 9001 Certified",
    rohsCompliant: "RoHS Compliant",
    globalStandards: "Global Quality Standards",
    compatibleWith: "Compatible with 20+ Major Brands",
    directReplacementsDesc: "Direct replacements for premium brands with significant cost savings",
    money: "Money",
    contactUsToday: "Contact us today for a free quote and see how much you can save",
    
    // Missing keys from Products.js
    connectorSolutions: "Connector Solutions",
    highSpeedData: "High-speed data transmission",
    needCustomConnectorSolution: "Need a Custom Connector Solution?",
    
    // Missing keys from Services.js
    ourServicesTitle: "Our Services",
    service: "Service",
    ourProcessTitle: "Our Process",
    readyToStartProject: "Ready to Start Your Project?",
    
    // Missing keys from Manufacturing.js
    customPlastic: "Custom plastic connector housing manufacturing",
    materialPA: "Materials: PA66, PA6, PBT, LCP, PPS",
    tolerance: "Tolerance: ±0.05mm precision",
    stampingWorkshop: "Stamping Workshop",
    precisionCopper: "Precision copper alloy terminal stamping",
    materialBrass: "Materials: Brass, Phosphor Bronze, Beryllium Copper",
    thickness: "Thickness range: 0.1mm - 3.0mm",
    inHouseMold: "In-house mold design and manufacturing",
    cadcad: "CAD/CAM/CAE design capabilities",
    moldMaintenance: "Mold maintenance and repair",
    cncMachining: "CNC Machining",
    highPrecision: "High-precision component machining",
    edm: "EDM (Electrical Discharge Machining)",
    wireCutting: "Wire cutting and profiling",
    cncMilling: "CNC milling and turning",
    surfaceFinishing: "Surface finishing and polishing",
    assemblyLines: "Assembly Lines",
    automatedConnector: "Automated connector assembly systems",
    semiAutomatic: "Semi-automatic assembly lines",
    fullyAutomatic: "Fully automatic production lines",
    inlineTesting: "In-line testing and quality control",
    cleanRoom: "Clean room assembly environment",
    rohsCertified: "RoHS certified quality control processes",
    incomingMaterial: "Incoming material inspection",
    finalProduct: "Final product testing",
    reliabilityTesting: "Environmental and reliability testing",
    restrictionHazardous: "Restriction of Hazardous Substances",
    qualityManagement: "Quality Management System",
    automotiveQuality: "Automotive Quality Management",
    safetyCertification: "Safety Certification",
    designReview: "Design Review",
    analyzeTechnical: "Analyze technical requirements and specifications",
    createSamples: "Create samples for validation and testing",
    developMolds: "Develop molds and production tooling",
    massProduction: "Mass production with quality control",
    comprehensiveInspection: "Comprehensive inspection and testing",
    packagingShipping: "Professional packaging and shipping",
    manufacturingCapabilities: "Manufacturing Capabilities",
    inHouseProduction: "In-House Production",
    manufacturingDescription: "Complete in-house manufacturing capabilities including injection molding, stamping, CNC machining, and assembly with strict quality control",
    completeInHouse: "Complete in-house manufacturing from design to delivery",
    capabilities: "Capabilities",
    ourCoreCapabilities: "Our Core Capabilities",
    stateOfTheArt: "State-of-the-art facilities and equipment for precision manufacturing",
    facility: "Facility",
    ourManufacturingProcess: "Our Manufacturing Process",
    industryCertifications: "Industry Certifications",
    readyToStartManufacturingProject: "Ready to Start Your Manufacturing Project?",
  },
  zh: {
    // SEO Meta Content
    seoTitle: "优质连接器替代品 - 节省50-70%成本 | 清顺电子",
    seoDescription: "领先的优质连接器替代品制造商。TE、Molex、Amphenol、JST直接替代品，节省50-70%成本。ISO认证，相同质量标准。服务全球1000+客户。",
    seoKeywords: "连接器替代品, TE替代品, Molex替代品, Amphenol替代品, 汽车连接器, 工业连接器, 成本节约, 优质连接器, 连接器制造商",
    seoFaqQ1: "连接器替代品能节省多少成本？",
    seoFaqA1: "我们的客户通常节省50-70%的成本，相比TE、Molex和Amphenol等主要品牌，同时保持相同的质量标准。",
    seoFaqQ2: "你们的连接器与主要品牌兼容吗？",
    seoFaqA2: "是的，我们的连接器是20多个主要品牌的直接替代品，包括TE、Molex、Amphenol、JST等。",
    seoFaqQ3: "你们服务哪些行业？",
    seoFaqA3: "我们为汽车、工业、医疗、消费电子和电信行业提供认证的连接器解决方案。",
    
    // Navigation
    home: "首页",
    about: "关于我们",
    services: "服务",
    products: "产品",
    industries: "行业",
    manufacturing: "制造",
    blog: "博客",
    contact: "联系",
    admin: "管理",
    
    // Hero Section
    premiumConnectorAlternatives: "优质连接器替代品",
    qualitySolutions: "高质量的解决方案，无需支付高昂的价格。自2011年以来，我们为8个国家的1000多个全球客户提供服务。",
    getAQuote: "获取报价",
    viewProducts: "查看产品",
    directReplacements: "直接替代20多个主要品牌",
    notYourBrand: "找不到您的品牌？联系我们获取定制解决方案。",
    
    // Cost Comparison
    savePercentage: "节省50-70%而不影响质量",
    sameSpecifications: "相同的规格，相同的性能，显著降低成本",
    originalBrand: "原品牌",
    qingshunAlternative: "清顺替代品",
    whyCostLess: "为什么我们的替代品成本更低",
    verticalIntegration: "垂直整合 - 我们控制整个生产过程",
    directSales: "直销模式消除了中间商",
    efficientManufacturing: "高效的自动化生产流程",
    noPremiumMarkup: "没有高端品牌加价或许可费用",
    costSavings: "成本节约",
    seeOurProducts: "查看我们的产品",
    competitivePricing: "我们的竞争优势来自于高效的流程和直销模式",
    significantSavings: "显著的成本节约",
    costSavingsDesc: "在不牺牲质量和性能的前提下节省50-70%的成本",
    verticalIntegrationDesc: "对整个生产链的控制降低了成本",
    efficientManufacturingDesc: "现代化自动化和优化流程",
    directSalesDesc: "消除中间商将节省的成本传递给您",
    noPremiumMarkupDesc: "无品牌溢价或许可费用",
    
    // Stats
    yearsExperience: "年经验",
    globalClients: "全球客户",
    countriesServed: "服务国家",
    costSavingsStats: "成本节约",
    
    // Brand Replacement
    replacingBrands: "替代主要品牌",
    alternativesPremium: "直接替代高端连接器品牌，显著节省成本",
    cantFindBrand: "找不到您的品牌？",
    alternativesAnyBrand: "我们可以为几乎任何连接器品牌创建替代品。请提供您的零件号以获取定制报价。",
    requestCustom: "请求定制替代品",
    
    // About Section
    yourTrustedPartner: "您值得信赖的连接器合作伙伴",
    companyDescription1: "苏州清顺电子科技有限公司是一家领先的制造商，专门生产高质量的连接器替代品和定制电缆组件。自2011年成立以来，我们一直致力于提供具有成本效益的解决方案，同时不妥协质量。",
    companyDescription2: "凭借14多年的经验，我们开发了全面的内部制造能力，从注塑成型和冲压到最终组装。这种垂直整合使我们能够在提供有竞争力的价格的同时保持严格的质量控制。",
    learnMore: "了解更多关于我们",
    
    // CTA
    readyToSave: "准备好在连接器上节省50-70%吗？",
    freeQuote: "立即联系我们获取免费报价，了解我们的优质替代品如何降低您的成本",
    getYourQuote: "获取您的报价",
    ourServices: "我们的服务",
    
    // Footer
    contactInfo: "联系信息",
    factoryAddress: "中国江苏省苏州市昆山市张浦镇花园路2526号",
    phone: "电话",
    wechat: "微信",
    whatsapp: "WhatsApp",
    email: "邮箱",
    quickLinks: "快速链接",
    allRights: "版权所有。",
    exportMarkets: "出口市场",
    privacyPolicy: "隐私政策",
    termsOfService: "服务条款",
    sitemap: "网站地图",
    globalExport: "全球出口",
    worldwideShipping: "全球运输，本地支持",
    servingClients: "为全球8多个国家的客户提供服务",
    worldwide: "全球",
    
    // Contact Page
    contactUs: "联系我们",
    getInTouch: "与我们的团队取得联系",
    sendMessage: "发送消息",
    yourName: "您的姓名",
    yourEmail: "您的邮箱",
    subject: "主题",
    message: "消息",
    send: "发送",
    
    // Products Page
    ourProducts: "我们的产品",
    highQualityAlternatives: "为各种应用提供高质量的连接器替代品",
    automotiveConnectors: "汽车连接器",
    automotiveDesc: "用于车辆系统的高可靠性连接器",
    medicalConnectors: "医疗连接器",
    medicalDesc: "用于医疗设备的精密连接器",
    industrialConnectors: "工业连接器",
    industrialDesc: "适用于恶劣环境的坚固连接器",
    consumerElectronics: "消费电子",
    consumerDesc: "用于便携设备的小型连接器",
    dataServer: "数据与服务器",
    dataDesc: "用于数据中心的高速连接器",
    energyStorage: "储能",
    energyDesc: "用于电池系统的连接器",
    brandsWeReplace: "我们替代的品牌",
    costEffective: "高端连接器品牌的成本效益替代品 - 节省50-70%的成本而不影响质量",
    needSpecific: "需要特定品牌的替代品？",
    alternativesAny: "我们可以为几乎任何连接器品牌创建替代品。请提供您的零件号以获取定制报价。",
    requestCustomAlternative: "请求定制替代品",
    productResources: "产品资源",
    downloadTechnical: "下载技术文档和规格",
    catalog: "目录",
    comprehensiveCatalog: "包含规格和尺寸的综合产品目录",
    downloadPDF: "下载PDF",
    datasheets: "数据表",
    technicalDatasheets: "我们所有连接器系列的技术数据表",
    needHelp: "需要帮助选择合适的产品？",
    technicalTeam: "我们的技术团队随时准备协助您进行产品选择和定制",
    contactTechnical: "联系技术支持",
    customSolutions: "定制解决方案",
    
    // Products Page - Additional Keys
    boardToBoard: "板对板",
    highDensity: "用于紧凑型电子设备的高密度连接器",
    pitchRange: "0.5mm至2.54mm间距范围",
    highSpeed: "支持高速数据传输",
    lowProfile: "低矮设计，适用于空间受限的应用",
    dualRow: "双排配置，提高电路密度",
    wireToBoard: "线对板",
    reliableConnections: "电线与PCB之间的可靠连接",
    singleDouble: "单排和双排配置",
    lockingMechanism: "锁定机制，确保连接安全",
    multipleWires: "多线端接选项",
    colorCoding: "颜色编码，便于识别",
    wireToWire: "线对线",
    flexibleSolutions: "灵活的线连接解决方案",
    crimpTerminal: "压接端子连接",
    insulationDisplacement: "绝缘置换技术",
    multipleCircuits: "单个连接器中的多个电路",
    environmentalProtection: "环境防护等级",
    usbConnectors: "USB连接器",
    universalConnectivity: "通用连接解决方案",
    usbTypes: "USB Type-A、Type-B、Type-C变体",
    powerDelivery: "功率传输高达100W",
    reversibleDesign: "可逆连接器设计",
    rfCoaxial: "射频和同轴",
    highFrequency: "高频信号传输",
    impedanceControl: "精密阻抗控制",
    lowInsertion: "低插入损耗特性",
    excellentShielding: "优异的电磁屏蔽",
    multipleFrequencies: "多频段支持",
    automotive: "汽车",
    harshEnvironment: "适用于恶劣环境的连接器",
    vibrationResistant: "抗震设计",
    temperatureRange: "-40°C至+125°C工作范围",
    sealedHousings: "密封外壳，防潮保护",
    automotiveStandards: "符合汽车标准",
    medical: "医疗",
    precisionReliability: "医疗设备的精密性和可靠性",
    biocompatible: "提供生物相容性材料",
    sterilizable: "可灭菌的连接器设计",
    lowNoise: "低噪声性能",
    miniaturized: "微型化外形",
    industrial: "工业",
    ruggedDurable: "坚固耐用的解决方案",
    highCurrent: "大电流承载能力",
    ipRated: "IP等级，防尘防水",
    corrosionResistant: "耐腐蚀材料",
    extendedTemperature: "扩展温度范围运行",
    dataCenter: "数据中心",
    highPerformance: "高性能计算连接器",
    lowLatency: "超低延迟传输",
    powerEfficient: "节能设计",
    rackMountable: "机架式解决方案",
    connector: "连接器",
    comprehensiveRange: "全面的连接器解决方案",
    connectorProducts: "连接器产品",
    connectors: "连接器",
    productsDescription: "探索我们为各种应用提供的高质量连接器替代品的全面系列",
    
    // About Page
    aboutUs: "关于我们",
    companyOverview: "公司概况",
    established: "清顺电子成立于2011年，已发展成为高质量连接器替代品的领先制造商。",
    ourMission: "我们的使命",
    missionText: "提供具有成本效益的高质量连接器解决方案，帮助客户在不影响性能的情况下降低成本。",
    ourVision: "我们的愿景",
    visionText: "成为连接器替代品领域的全球领导者，以我们的创新、质量和客户服务而闻名。",
    ourValues: "我们的价值观",
    value1: "质量第一 - 我们从不妥协质量",
    value2: "客户至上 - 您的成功就是我们的成功",
    value3: "创新 - 不断改进我们的产品和流程",
    value4: "诚信 - 在所有交易中诚实透明",
    facilities: "我们的设施",
    facility1: "15,000平方英尺的制造工厂",
    facility2: "先进的注塑设备",
    facility3: "精密冲压机",
    facility4: "自动化装配线",
    certifications: "认证",
    certified: "我们获得了国际质量管理和环境管理标准的认证。",
    iso9001: "ISO 9001:2015 质量管理",
    iso14001: "ISO 14001:2015 环境管理",
    rohs: "RoHS 合规",
    reach: "REACH 合规",
    meetOurTeam: "认识我们的团队",
    tonyChen: "陈先生",
    tonyTitle: "创始人兼首席执行官",
    tonyBio: "拥有超过15年的电子行业经验，Tony以远见和专业知识领导我们的公司。",
    sarahJohnson: "莎拉·约翰逊",
    sarahTitle: "技术总监",
    sarahBio: "莎拉拥有超过12年的工程经验，负责我们的技术运营和产品开发。",
    michaelWong: "黄先生",
    michaelTitle: "运营经理",
    michaelBio: "迈克尔确保我们的制造流程高效运行并符合最高质量标准。",
    
    // Services Page
    ourServices: "我们的服务",
    comprehensiveOfferings: "量身定制的全面制造服务",
    connectorReplacement: "连接器替代",
    replacementDesc: "直接替代高端连接器品牌，显著节省成本",
    customManufacturing: "定制制造",
    customDesc: "根据您的确切规格设计和制造的定制连接器解决方案",
    cableAssembly: "电缆组装",
    cableDesc: "从设计到生产的完整电缆组装服务",
    qualityControl: "质量控制",
    qualityDesc: "严格的测试和检验流程以确保产品可靠性",
    rapidPrototyping: "快速原型制作",
    prototypeDesc: "快速周转的原型制作服务，加速您的产品开发",
    supplyChain: "供应链解决方案",
    supplyDesc: "端到端的供应链管理，优化您的采购流程",
    valueAdded: "增值服务",
    valueAddedDesc: "包括套件、标签和包装在内的附加服务",
    process: "我们的流程",
    consultation: "咨询",
    consultationDesc: "我们与您合作，了解您的需求和目标",
    design: "设计",
    designDesc: "我们的工程师创建详细的设计和规格",
    prototyping: "原型制作",
    prototypingDesc: "我们构建原型进行测试和验证",
    production: "生产",
    productionDesc: "严格质量控制的大规模生产",
    delivery: "交付",
    deliveryDesc: "按您的规格及时交付",
    support: "支持",
    supportDesc: "持续的技术支持和服务",
    fastDelivery: "快速交付",
    quickTurnaround: "快速周转",
    completeProduction: "完整生产",
    customSolutions: "定制解决方案",
    tailoredDesigns: "量身定制的设计",
    qualityGuarantee: "质量保证",
    testedProducts: "经过测试的产品",
    
    // Industries Page
    industriesServed: "服务行业",
    diverseApplications: "为各行业提供专业连接器解决方案",
    automotive: "汽车",
    automotiveText: "用于发动机控制、信息娱乐、安全系统和电动汽车应用的连接器",
    medical: "医疗",
    medicalText: "用于诊断设备、患者监护和手术器械的精密连接器",
    industrial: "工业",
    industrialText: "用于自动化、机器人和过程控制系统的坚固连接器",
    consumer: "消费电子",
    consumerText: "用于智能手机、平板电脑、可穿戴设备和智能家居设备的小型连接器",
    dataCenters: "数据中心",
    dataCentersText: "用于服务器、存储阵列和网络设备的高速连接器",
    energy: "能源与公用事业",
    energyText: "用于太阳能系统、电池存储和电网基础设施的连接器",
    aerospace: "航空航天与国防",
    aerospaceText: "用于航空电子和国防应用的高可靠性连接器",
    telecommunications: "电信",
    telecommunicationsText: "用于基站、光纤网络和5G基础设施的连接器",
    whyChooseIndustries: "为什么为您的行业选择我们",
    industryExpertise: "行业专业知识",
    expertiseText: "深入了解行业特定要求和标准",
    customizedSolutions: "定制解决方案",
    customizedText: "量身定制的产品以满足独特的应用挑战",
    compliance: "合规",
    complianceText: "遵守行业标准和认证",
    globalSupport: "全球支持",
    globalText: "为国际客户提供全球支持和服务",
    
    // Additional Industries Page Keys
    vehicleSystems: "用于关键车辆系统的连接器",
    engineControl: "发动机控制单元 (ECUs)",
    infotainment: "信息娱乐系统",
    safetyADAS: "安全与ADAS系统",
    electricVehicle: "电动汽车 (EV) 系统",
    powertrain: "动力总成控制系统",
    automotiveApplications: "发动机管理、信息娱乐、安全系统、电动汽车电池管理及自动驾驶技术",
    medicalDevices: "医疗器械",
    highReliability: "高可靠性精密连接器",
    patientMonitoring: "患者监护设备",
    diagnosticEquipment: "诊断成像系统",
    surgicalInstruments: "外科及微创器械",
    imagingSystems: "MRI、CT和超声系统",
    laboratoryEquipment: "实验室自动化设备",
    medicalApplications: "患者监护、诊断成像、外科器械、实验室自动化和远程医疗设备",
    industrialAutomation: "工业自动化",
    controlMonitoring: "控制与监控系统",
    plcSystems: "可编程逻辑控制器 (PLCs)",
    robotics: "工业机器人",
    sensorsActuators: "传感器与执行器",
    industrialNetworking: "工业网络",
    processControl: "过程控制系统",
    industrialApplications: "工厂自动化、机器人、过程控制、传感器和工业物联网应用",
    energyStorage: "储能",
    batteryManagement: "电池管理系统",
    batteryPacks: "电池组连接器",
    energyStorageCabinets: "储能柜",
    powerDistribution: "配电单元",
    solarSystems: "太阳能板系统",
    upsSystems: "UPS及备用电源系统",
    energyApplications: "太阳能装置、电池储能系统、电网基础设施和备用电源解决方案",
    aviationDefense: "航空与国防系统",
    avionics: "航空电子系统",
    flightControl: "飞行控制系统",
    communicationSystems: "通信系统",
    navigationEquipment: "导航设备",
    defenseElectronics: "国防电子设备",
    aerospaceApplications: "飞机航空电子、飞行控制、导航系统、卫星通信和国防电子设备",
    serverData: "服务器与数据中心",
    dataCenters: "数据中心基础设施",
    serverSystems: "服务器系统",
    storageArrays: "存储阵列",
    networkingEquipment: "网络设备",
    cloudInfrastructure: "云基础设施",
    serverApplications: "高性能计算、数据存储、网络基础设施和云计算平台",
    communicationInfrastructure: "通信基础设施",
    fiveG: "5G网络基础设施",
    networkEquipment: "网络设备",
    fiberOptic: "光纤连接",
    wirelessSystems: "无线通信系统",
    satelliteCommunications: "卫星通信",
    telecomApplications: "5G基站、光纤网络、无线基础设施和卫星通信",
    personalDevices: "个人电子设备",
    smartphones: "智能手机",
    tablets: "平板电脑",
    wearables: "可穿戴设备",
    smartHome: "智能家居设备",
    audioEquipment: "音频设备",
    consumerApplications: "移动设备、平板电脑、可穿戴设备、智能家居产品、游戏机和音频设备",
    industriesDescription: "了解清顺电子如何在汽车、医疗、工业、能源、航空航天、数据中心、电信和消费电子等不同行业提供专业连接器解决方案。",
    providingReliable: "提供可靠、高性能的连接器解决方案，针对我们服务的每个行业的独特需求量身定制。",
    keyApplications: "关键应用",
    solutionsWeProvide: "我们提供的解决方案",
    needSolutionsSpecificIndustry: "需要特定行业的解决方案？",
    engineeringTeam: "我们的工程团队已准备好为您的行业特定需求设计和制造定制连接器解决方案。",
    talkToExpert: "与专家交谈",
    industriesWeServe: "我们服务的行业",
    
    // Manufacturing Page
    manufacturingProcess: "制造流程",
    inHouseCapabilities: "完整的内部制造能力",
    injectionMolding: "注塑成型",
    moldingDesc: "先进的注塑成型，用于具有精密公差的连接器外壳",
    stamping: "冲压",
    stampingDesc: "用于连接器端子和触点的高精度冲压",
    plating: "电镀",
    platingDesc: "表面处理，包括金、锡和其他专业涂层",
    assembly: "组装",
    assemblyDesc: "用于完整连接器解决方案的自动化和手动组装流程",
    testing: "测试",
    testingDesc: "包括电气、机械和环境验证的综合测试",
    qualityAssurance: "质量保证",
    assuranceDesc: "整个制造过程中的严格质量控制",
    equipment: "我们的设备",
    equipmentText: "最先进的制造设备，确保精度和一致性",
    moldingMachine: "注塑机",
    stampingPress: "精密冲压机",
    platingLine: "自动化电镀线",
    assemblyLine: "自动化装配线",
    testingEquipment: "先进测试设备",
    environmentalChamber: "环境测试室",
    productionCapacity: "生产能力",
    capacityText: "高产量生产能力以满足您的需求",
    monthlyCapacity: "月生产能力",
    qualityControlProcess: "质量控制流程",
    controlProcess: "我们全面的质量控制流程确保一致的产品质量",
    incomingInspection: "来料检验",
    incomingText: "对所有原材料和组件进行彻底检查",
    inProcess: "过程质量检查",
    inProcessText: "制造过程中的持续监控",
    finalTesting: "最终产品测试",
    finalText: "成品的综合测试",
    documentation: "文档与可追溯性",
    documentationText: "详细的记录以实现完整的产品可追溯性",
    
    // Blog Page
    ourBlog: "我们的博客",
    insights: "连接器技术、制造趋势和行业新闻的见解",
    stayUpdated: "随时了解我们的见解",
    subscribe: "订阅我们的新闻通讯，获取最新的博客文章和行业新闻",
    yourEmail: "您的邮箱地址",
    subscribeButton: "订阅",
    
    // 404 Page
    pageNotFound: "页面未找到",
    pageNotFoundText: "您要查找的页面不存在或已被移动。让我们帮您回到正轨。",
    quickNavigation: "快速导航",
    returnHome: "返回首页",
    browseProducts: "浏览产品",
    needHelp404: "需要帮助？",
    help404: "如果您在寻找内容时遇到困难，我们的团队随时为您提供帮助。",
    contactSupport: "联系支持",
    callUs: "致电我们",
    errorReference: "错误代码：404 - 页面未找到",
    backToBusiness: "回到清顺电子业务",
    goToPage: "转到页面",
    goBack: "返回",
    goodMorning: "早上好",
    goodAfternoon: "下午好",
    goodEvening: "晚上好",
    didYouKnow: "您知道吗？",
    pageTip: "请检查URL是否有错误或使用上面的导航。",
    trustedBy: "自2011年以来，已获得1000多个全球客户的信任",
    
    // Theme Toggle
    switchToLight: "切换到浅色模式",
    switchToDark: "切换到深色模式",
    
    // Contact Page
    needCustom: "需要定制",
    connectorSolution: "连接器解决方案",
    engineeringTeam: "我们的工程团队已准备好为您的特定需求设计和制造定制连接器解决方案。",
    requestQuote: "请求报价",
    viewAllServices: "查看所有服务",
    
    // Missing keys for Services page
    connectorManufacturing: "连接器制造",
    connectorManufacturingDesc: "从设计到生产的完整连接器制造服务",
    customConnectorDesign: "定制连接器设计与工程",
    materialSelection: "材料选择与采购",
    precisionManufacturing: "精密制造，公差严格",
    qualityAssurance: "全面的质量保证测试",
    stampingServices: "冲压服务",
    stampingServicesDesc: "用于连接器端子和触点的高精度冲压",
    progressiveDie: "连续模冲压复杂零件",
    materialPlating: "材料电镀和表面处理",
    tightTolerance: "精密公差冲压能力",
    volumeProduction: "大批量生产",
    moldDevelopment: "模具开发",
    moldDevelopmentDesc: "连接器外壳的定制模具设计与开发",
    cadcadDesign: "CAD/CAE设计与仿真",
    moldFlow: "模流分析与优化",
    maintenanceRepair: "模具维护与维修服务",
    injectionMolding: "注塑成型",
    injectionMoldingDesc: "用于连接器外壳的先进注塑成型",
    multiCavity: "多腔模具生产",
    materialEngineering: "材料工程与选择",
    precisionTolerances: "精密公差控制",
    highVolume: "大批量生产能力",
    cableAssembly: "电缆组装",
    cableAssemblyDesc: "从设计到生产的完整电缆组装服务",
    customWire: "定制线束设计",
    connectorAssembly: "连接器组装与端接",
    testingValidation: "测试与验证服务",
    ulCertification: "UL及其他认证支持",
    qualityControlDesc: "整个制造过程中的严格质量控制",
    incomingInspection: "来料检验",
    inProcessControl: "过程质量控制",
    finalTesting: "最终产品测试与验证",
    documentationCertification: "文档与认证支持",
    tooling: "工装",
    toolingDesc: "生产用工具设计与准备",
    testingDesc: "全面测试与验证",
    servicesDescription: "为定制连接器和电缆组件提供完整的制造服务，并保证质量",
    electronicsManufacturing: "电子制造",
    our: "我们的",
    comprehensiveServices: "量身定制的全面制造服务",
    fromConcept: "从概念到完成，我们在每个步骤都确保质量",
    readyToStart: "准备好开始您的",
    project: "项目",
    contactUsDiscuss: "立即联系我们讨论您的制造需求",
    getInTouch: "取得联系",
    
    // Missing keys for About page
    companyFounded: "公司成立",
    establishedSuzhou: "在中国苏州成立，专注于连接器制造",
    internationalExpansion: "国际扩张",
    firstExports: "首次向欧洲和北美市场出口",
    rohsCertification: "RoHS认证",
    achievedCompliance: "获得RoHS合规认证，符合环保标准",
    thousandClients: "1000+全球客户",
    reachedMilestone: "达到服务1000多个全球客户的里程碑",
    advancedAutomation: "先进自动化",
    upgradedFacilities: "升级设施，采用先进的自动化技术",
    globalLeader: "全球领导者",
    servingCountries: "为8多个国家的客户提供服务",
    qualityFirst: "质量第一",
    qualityFirstDesc: "我们在运营的各个方面都绝不妥协质量",
    customerFocus: "客户至上",
    customerFocusDesc: "您的成功就是我们的成功 - 我们与客户密切合作以满足他们的特定需求",
    innovation: "创新",
    innovationDesc: "通过创新不断改进我们的产品和流程",
    globalReach: "全球覆盖",
    globalReachDesc: "为多个国家的客户提供服务，并提供本地化支持",
    yearsInBusiness: "经营年数",
    brandsReplaced: "替代品牌",
    annualProduction: "年产量",
    qualityTested: "质量测试",
    aboutDescription: "了解清顺电子，自2011年以来一直专注于高质量连接器替代品和定制电缆组件的领先制造商。",
    aboutPageDescription: "关于清顺电子 - 领先的连接器替代品和定制电缆组件制造商",
    leadingManufacturer: "专注于高质量连接器替代品和定制电缆组件的领先制造商",
    whoWeAre: "我们是谁",
    weAre: "我们是",
    productsServe: "我们的产品服务于汽车、医疗、工业和消费电子等不同行业，提供具有成本效益的解决方案。",
    factoryImageAlt: "清顺电子制造工厂外景",
    coreValues: "核心价值观",
    principlesGuide: "指导我们业务运营和关系的原则",
    ourJourney: "我们的历程",
    journey: "发展历程",
    keyMilestones: "公司发展和成长的关键里程碑",
    quality: "质量",
    certificationsQuality: "认证与质量",
    committedStandards: "致力于最高标准的质量和合规性",
    
    // Missing keys for Contact page
    us: "我们",
    contactDescription: "联系清顺电子获取产品报价、定制制造服务、技术支持或合作机会。我们随时准备帮助您解决连接器需求。",
    generalInquiry: "一般咨询",
    productQuote: "产品报价请求",
    customManufacturing: "定制制造",
    technicalSupport: "技术支持",
    partnershipOpportunity: "合作机会",
    other: "其他",
    messageSent: "消息已发送！",
    thankYouMessage: "感谢您联系我们。我们会尽快回复您。",
    company: "公司",
    yourCompany: "您的公司名称",
    selectSubject: "选择主题",
    howCanWeHelp: "我们如何帮助您？",
    attachment: "附件",
    optional: "可选",
    chooseFile: "选择文件",
    maxFileSize: "最大文件大小：10MB",
    companyInformation: "公司信息",
    address: "地址",
    businessHours: "营业时间",
    businessHoursDetails: "周一至周五：上午8:00 - 下午6:00（GMT+8）",
    whyChooseQingshun: "为什么选择清顺",
    comparedToBrands: "相比高端品牌",
    certifiedManufacturing: "认证制造",
    yearsOfExperience: "年经验",
    globalExport: "全球出口能力",
    contactToday: "立即联系我们获取免费报价！",
    
    // Missing keys from Home.js
    comprehensiveSolutions: "为您的连接器需求提供全面解决方案",
    aboutOurCompany: "关于我们的公司",
    isoCertified: "ISO 9001认证",
    rohsCompliant: "RoHS合规",
    globalStandards: "全球质量标准",
    compatibleWith: "兼容20多个主要品牌",
    directReplacementsDesc: "直接替代高端品牌，显著节省成本",
    money: "费用",
    contactUsToday: "立即联系我们获取免费报价，看看您能节省多少",
    
    // Missing keys from Products.js
    connectorSolutions: "连接器解决方案",
    highSpeedData: "高速数据传输",
    needCustomConnectorSolution: "需要定制连接器解决方案吗？",
    
    // Missing keys from Services.js
    ourServicesTitle: "我们的服务",
    service: "服务",
    ourProcessTitle: "我们的流程",
    readyToStartProject: "准备好开始您的项目了吗？",
    
    // Missing keys from Manufacturing.js
    customPlastic: "定制塑料连接器外壳制造",
    materialPA: "材料：PA66、PA6、PBT、LCP、PPS",
    tolerance: "公差：±0.05mm精度",
    stampingWorkshop: "冲压车间",
    precisionCopper: "精密铜合金端子冲压",
    materialBrass: "材料：黄铜、磷青铜、铍铜",
    thickness: "厚度范围：0.1mm - 3.0mm",
    inHouseMold: "内部模具设计与制造",
    cadcad: "CAD/CAM/CAE设计能力",
    moldMaintenance: "模具维护与维修",
    cncMachining: "CNC加工",
    highPrecision: "高精度零件加工",
    edm: "电火花加工（EDM）",
    wireCutting: "线切割与成型",
    cncMilling: "CNC铣削与车削",
    surfaceFinishing: "表面处理与抛光",
    assemblyLines: "装配线",
    automatedConnector: "自动化连接器装配系统",
    semiAutomatic: "半自动装配线",
    fullyAutomatic: "全自动生产线",
    inlineTesting: "在线测试与质量控制",
    cleanRoom: "洁净室装配环境",
    rohsCertified: "RoHS认证的质量控制流程",
    incomingMaterial: "来料检验",
    finalProduct: "最终产品测试",
    reliabilityTesting: "环境与可靠性测试",
    restrictionHazardous: "有害物质限制",
    qualityManagement: "质量管理体系",
    automotiveQuality: "汽车质量管理",
    safetyCertification: "安全认证",
    designReview: "设计评审",
    analyzeTechnical: "分析技术要求和规格",
    createSamples: "创建样品以进行验证和测试",
    developMolds: "开发模具和生产工装",
    massProduction: "批量生产并进行质量控制",
    comprehensiveInspection: "全面检验与测试",
    packagingShipping: "专业包装与运输",
    manufacturingCapabilities: "制造能力",
    inHouseProduction: "内部生产",
    manufacturingDescription: "完整的内部制造能力，包括注塑成型、冲压、CNC加工和装配，严格的质量控制",
    completeInHouse: "从设计到交付的完整内部制造",
    capabilities: "能力",
    ourCoreCapabilities: "我们的核心能力",
    stateOfTheArt: "用于精密制造的最先进设施和设备",
    facility: "设施",
    ourManufacturingProcess: "我们的制造流程",
    industryCertifications: "行业认证",
    readyToStartManufacturingProject: "Preparado para comenzar su proyecto de fabricación?",
  },
  
  zh: {
    // Navigation
    home: "首页",
    about: "关于我们",
    services: "服务",
    products: "产品",
    industries: "行业",
    manufacturing: "制造",
    blog: "博客",
    contact: "联系",
    admin: "管理",
    
    // Hero Section
    premiumConnectorAlternatives: "优质连接器替代品",
    qualitySolutions: "高质量的解决方案，无需支付高昂的价格。自2011年以来，我们为8个国家的1000多个全球客户提供服务。",
    getAQuote: "获取报价",
    viewProducts: "查看产品",
    directReplacements: "直接替代20多个主要品牌",
    notYourBrand: "找不到您的品牌？我们为任何连接器品牌提供定制解决方案。",
    
    // Cost Comparison
    
    // Cost Comparison
    savePercentage: "Ahorre 50-70% Sin Comprometer la Calidad",
    sameSpecifications: "Mismas especificaciones, mismo rendimiento, costo significativamente menor",
    originalBrand: "Marca Original",
    qingshunAlternative: "Alternativa Qingshun",
    whyCostLess: "Por Qué Nuestras Alternativas Cuestan Menos",
    verticalIntegration: "Integración vertical - controlamos todo el proceso de producción",
    directSales: "Modelo de ventas directas al cliente elimina intermediarios",
    efficientManufacturing: "Fabricación eficiente con procesos automatizados",
  },
  
  es: {
    // SEO Meta Content
    seoTitle: "Alternativas Premium de Conectores - Ahorre 50-70% | Qingshun Electronics",
    seoDescription: "Fabricante líder de alternativas de conectores de alta calidad. Reemplazos directos para TE, Molex, Amphenol, JST con 50-70% de ahorro. Certificado ISO, mismos estándares de calidad. 1000+ clientes globales.",
    seoKeywords: "alternativas de conectores, alternativa TE, alternativa Molex, alternativa Amphenol, conectores automotrices, conectores industriales, ahorro de costos, conectores de calidad",
    seoFaqQ1: "¿Cuánto puedo ahorrar con alternativas de conectores?",
    seoFaqA1: "Nuestros clientes típicamente ahorran 50-70% comparado con marcas principales como TE, Molex y Amphenol, manteniendo los mismos estándares de calidad.",
    seoFaqQ2: "¿Sus conectores son compatibles con marcas principales?",
    seoFaqA2: "Sí, nuestros conectores son reemplazos directos para más de 20 marcas principales incluyendo TE, Molex, Amphenol, JST y más.",
    seoFaqQ3: "¿Qué industrias atienden?",
    seoFaqA3: "Atendemos las industrias automotriz, industrial, médica, electrónica de consumo y telecomunicaciones con soluciones de conectores certificadas.",
    
    // Navigation
    home: "Inicio",
    about: "Acerca de",
    services: "Servicios",
    products: "Productos",
    industries: "Industrias",
    manufacturing: "Fabricación",
    blog: "Blog",
    contact: "Contacto",
    admin: "Admin",
    
    // Hero Section
    premiumConnectorAlternatives: "Soluciones Premium de Conectores",
    qualitySolutions: "Soluciones de calidad sin el precio premium. Sirviendo a más de 1000 clientes globales en 8+ países desde 2011.",
    getAQuote: "Obtener una Cotización",
    viewProducts: "Ver Productos",
    directReplacements: "Reemplazos directos para más de 20 marcas principales",
    notYourBrand: "¿No encuentra su marca? Ofrecemos soluciones personalizadas para cualquier marca de conectores.",
    
    // Cost Comparison
    savePercentage: "Ahorre 50-70% Sin Comprometer la Calidad",
    sameSpecifications: "Mismas especificaciones, mismo rendimiento, costo significativamente menor",
    originalBrand: "Marca Original",
    qingshunAlternative: "Alternativa Qingshun",
    whyCostLess: "Por Qué Nuestras Alternativas Cuestan Menos",
    verticalIntegration: "Integración vertical - controlamos todo el proceso de producción",
    directSales: "Modelo de ventas directas al cliente elimina intermediarios",
    efficientManufacturing: "Fabricación eficiente con procesos automatizados",
    noPremiumMarkup: "Sin márgenes de marca premium ni tarifas de licencia",
    costSavings: "Ahorro de Costos",
    seeOurProducts: "Ver Nuestros Productos",
    competitivePricing: "Nuestros precios competitivos provienen de procesos eficientes y ventas directas",
    significantSavings: "Ahorros Significativos en Costos",
    costSavingsDesc: "Experimente ahorros del 50-70% sin comprometer la calidad o el rendimiento",
    verticalIntegrationDesc: "El control de toda la cadena de producción reduce los costos",
    efficientManufacturingDesc: "Automatización moderna y procesos optimizados",
    directSalesDesc: "Eliminar intermediarios transfiere los ahorros a usted",
    noPremiumMarkupDesc: "Sin marca premium ni tarifas de licencia",
    
    // Stats
    yearsExperience: "Años de Experiencia",
    globalClients: "Clientes Globales",
    countriesServed: "Países Atendidos",
    costSavingsStats: "Ahorro de Costos",
    
    // Brand Replacement
    replacingBrands: "Reemplazando Marcas Principales",
    alternativesPremium: "Alternativas directas a marcas premium de conectores con ahorros significativos",
    cantFindBrand: "¿No encuentra su marca?",
    alternativesAnyBrand: "Podemos crear alternativas para prácticamente cualquier marca de conectores. Contáctenos con su número de parte para una cotización personalizada.",
    requestCustom: "Solicitar Alternativa Personalizada",
    
    // About Section
    yourTrustedPartner: "Su Socio de Conectores de Confianza",
    companyDescription1: "Suzhou Qingshun Electronics Technology Co., Ltd. es un fabricante líder especializado en alternativas de conectores de alta calidad y conjuntos de cables personalizados. Desde nuestra fundación en 2011, nos hemos comprometido a proporcionar soluciones rentables sin comprometer la calidad.",
    companyDescription2: "Con más de 14 años de experiencia, hemos desarrollado capacidades integrales de fabricación interna, desde moldeo por inyección y estampado hasta ensamblaje final. Esta integración vertical nos permite mantener un control de calidad estricto mientras ofrecemos precios competitivos.",
    learnMore: "Más Sobre Nosotros",
    
    // CTA
    readyToSave: "¿Listo para Ahorrar 50-70% en Conectores?",
    freeQuote: "Contáctenos hoy para una cotización gratuita y descubra cómo nuestras alternativas premium pueden reducir sus costos",
    getYourQuote: "Obtener Su Cotización",
    ourServices: "Nuestros Servicios",
    
    // Footer
    contactInfo: "Información de Contacto",
    factoryAddress: "2526 Huayuan Road, Zhangpu Town, Kunshan City, Suzhou, Jiangsu, China",
    phone: "Teléfono",
    wechat: "WeChat",
    whatsapp: "WhatsApp",
    email: "Correo Electrónico",
    quickLinks: "Enlaces Rápidos",
    allRights: "Todos los derechos reservados.",
    exportMarkets: "Mercados de Exportación",
    privacyPolicy: "Política de Privacidad",
    termsOfService: "Términos de Servicio",
    sitemap: "Mapa del Sitio",
    globalExport: "Exportación Global",
    worldwideShipping: "Envío mundial con soporte local",
    servingClients: "Atendiendo clientes en más de 8 países en todo el mundo",
    worldwide: "Mundial",
    
    // Contact Page
    contactUs: "Contáctenos",
    getInTouch: "Póngase en contacto con nuestro equipo",
    sendMessage: "Enviar Mensaje",
    yourName: "Su Nombre",
    yourEmail: "Su Correo Electrónico",
    subject: "Asunto",
    message: "Mensaje",
    send: "Enviar",
    
    // Products Page
    ourProducts: "Nuestros Productos",
    highQualityAlternatives: "Alternativas de conectores de alta calidad para diversas aplicaciones",
    automotiveConnectors: "Conectores Automotrices",
    automotiveDesc: "Conectores de alta confiabilidad para sistemas de vehículos",
    medicalConnectors: "Conectores Médicos",
    medicalDesc: "Conectores de precisión para equipos médicos",
    industrialConnectors: "Conectores Industriales",
    industrialDesc: "Conectores robustos para entornos hostiles",
    consumerElectronics: "Electrónica de Consumo",
    consumerDesc: "Conectores miniatura para dispositivos portátiles",
    dataServer: "Datos y Servidor",
    dataDesc: "Conectores de alta velocidad para centros de datos",
    energyStorage: "Almacenamiento de Energía",
    energyDesc: "Conectores para sistemas de baterías",
    brandsWeReplace: "Marcas que Reemplazamos",
    costEffective: "Alternativas rentables a marcas premium de conectores - Ahorre 50-70% sin comprometer la calidad",
    needSpecific: "¿Necesita una Alternativa de Marca Específica?",
    alternativesAny: "Podemos crear alternativas para prácticamente cualquier marca de conectores. Contáctenos con su número de parte para una cotización personalizada.",
    requestCustomAlternative: "Solicitar Alternativa Personalizada",
    productResources: "Recursos del Producto",
    downloadTechnical: "Descargue documentación técnica y especificaciones",
    catalog: "Catálogo",
    comprehensiveCatalog: "Catálogo de productos integral con especificaciones y dimensiones",
    downloadPDF: "Descargar PDF",
    datasheets: "Hojas de Datos",
    technicalDatasheets: "Hojas de datos técnicas para todas nuestras series de conectores",
    needHelp: "¿Necesita Ayuda para Elegir el Producto Correcto?",
    technicalTeam: "Nuestro equipo técnico está listo para ayudarle con la selección y personalización de productos",
    contactTechnical: "Contactar Soporte Técnico",
    customSolutions: "Soluciones Personalizadas",
    
    // Products Page - Additional Keys
    boardToBoard: "Placa a Placa",
    highDensity: "Conectores de alta densidad para electrónica compacta",
    pitchRange: "Rango de paso de 0.5mm a 2.54mm",
    highSpeed: "Soporte para transmisión de datos de alta velocidad",
    lowProfile: "Diseños de perfil bajo para aplicaciones con espacio limitado",
    dualRow: "Configuraciones de doble fila para mayor densidad de circuitos",
    wireToBoard: "Cable a Placa",
    reliableConnections: "Conexiones confiables entre cables y PCBs",
    singleDouble: "Configuraciones de fila simple y doble",
    lockingMechanism: "Mecanismos de bloqueo para conexiones seguras",
    multipleWires: "Opciones de terminación de múltiples cables",
    colorCoding: "Codificación por colores para fácil identificación",
    wireToWire: "Cable a Cable",
    flexibleSolutions: "Soluciones flexibles para conexiones de cables",
    crimpTerminal: "Conexiones de terminales de prensado",
    insulationDisplacement: "Tecnología de desplazamiento de aislamiento",
    multipleCircuits: "Múltiples circuitos en conectores individuales",
    environmentalProtection: "Clasificaciones de protección ambiental",
    usbConnectors: "Conectores USB",
    universalConnectivity: "Soluciones de conectividad universal",
    usbTypes: "Variantes USB Tipo-A, Tipo-B, Tipo-C",
    powerDelivery: "Entrega de energía de hasta 100W",
    reversibleDesign: "Diseños de conectores reversibles",
    rfCoaxial: "RF y Coaxial",
    highFrequency: "Transmisión de señales de alta frecuencia",
    impedanceControl: "Control de impedancia de precisión",
    lowInsertion: "Características de baja pérdida de inserción",
    excellentShielding: "Excelente blindaje electromagnético",
    multipleFrequencies: "Soporte para múltiples rangos de frecuencia",
    automotive: "Automotriz",
    harshEnvironment: "Conectores para entornos hostiles",
    vibrationResistant: "Diseños resistentes a vibraciones",
    temperatureRange: "Rango de operación de -40°C a +125°C",
    sealedHousings: "Housings sellados para protección contra la humedad",
    automotiveStandards: "Cumple con estándares automotrices",
    medical: "Médico",
    precisionReliability: "Precisión y confiabilidad para dispositivos médicos",
    biocompatible: "Materiales biocompatibles disponibles",
    sterilizable: "Diseños de conectores esterilizables",
    lowNoise: "Rendimiento de bajo ruido",
    miniaturized: "Factores de forma miniaturizados",
    industrial: "Industrial",
    ruggedDurable: "Soluciones robustas y duraderas",
    highCurrent: "Capacidad de transporte de corriente alta",
    ipRated: "Clasificado IP para protección contra polvo y agua",
    corrosionResistant: "Materiales resistentes a la corrosión",
    extendedTemperature: "Operación en rango de temperatura extendido",
    dataCenter: "Centro de Datos",
    highPerformance: "Conectores informáticos de alto rendimiento",
    lowLatency: "Transmisión de ultra baja latencia",
    powerEfficient: "Diseños eficientes en energía",
    rackMountable: "Soluciones montables en rack",
    connector: "Conector",
    comprehensiveRange: "Amplia gama de soluciones de conectores",
    connectorProducts: "Productos de Conectores",
    connectors: "Conectores",
    productsDescription: "Explore nuestra amplia gama de alternativas de conectores de alta calidad para diversas aplicaciones",
    
    // About Page
    aboutUs: "Acerca de Nosotros",
    companyOverview: "Resumen de la Empresa",
    established: "Establecida en 2011, Qingshun Electronics se ha convertido en un fabricante líder de alternativas de conectores de alta calidad.",
    ourMission: "Nuestra Misión",
    missionText: "Proporcionar soluciones de conectores rentables y de alta calidad que ayuden a nuestros clientes a reducir costos sin comprometer el rendimiento.",
    ourVision: "Nuestra Visión",
    visionText: "Ser el líder global en alternativas de conectores, reconocidos por nuestra innovación, calidad y servicio al cliente.",
    ourValues: "Nuestros Valores",
    value1: "Calidad Primero - Nunca comprometemos la calidad",
    value2: "Enfoque en el Cliente - Su éxito es nuestro éxito",
    value3: "Innovación - Mejorando constantemente nuestros productos y procesos",
    value4: "Integridad - Honestos y transparentes en todas nuestras operaciones",
    facilities: "Nuestras Instalaciones",
    facility1: "Instalación de fabricación de 15,000 pies cuadrados",
    facility2: "Equipos avanzados de moldeo por inyección",
    facility3: "Máquinas de estampado de precisión",
    facility4: "Líneas de ensamblaje automatizadas",
    certifications: "Certificaciones",
    certified: "Estamos certificados según estándares internacionales de gestión de calidad y ambiental.",
    iso9001: "Gestión de Calidad ISO 9001:2015",
    iso14001: "Gestión Ambiental ISO 14001:2015",
    rohs: "Cumplimiento RoHS",
    reach: "Cumplimiento REACH",
    meetOurTeam: "Conozca a Nuestro Equipo",
    tonyChen: "Tony Chen",
    tonyTitle: "Fundador y Director Ejecutivo",
    tonyBio: "Con más de 15 años de experiencia en la industria electrónica, Tony lidera nuestra empresa con visión y experiencia.",
    sarahJohnson: "Sarah Johnson",
    sarahTitle: "Directora Técnica",
    sarahBio: "Sarah supervisa nuestras operaciones técnicas y desarrollo de productos con más de 12 años de experiencia en ingeniería.",
    michaelWong: "Michael Wong",
    michaelTitle: "Gerente de Operaciones",
    michaelBio: "Michael asegura que nuestros procesos de fabricación se ejecuten eficientemente y cumplan con los más altos estándares de calidad.",
    
    // Services Page
    ourServices: "Nuestros Servicios",
    comprehensiveOfferings: "Servicios de fabricación integrales adaptados a sus necesidades",
    connectorReplacement: "Reemplazo de Conectores",
    replacementDesc: "Alternativas directas a marcas premium de conectores con ahorros significativos",
    customManufacturing: "Fabricación Personalizada",
    customDesc: "Soluciones de conectores personalizadas diseñadas y fabricadas según sus especificaciones exactas",
    cableAssembly: "Ensamblaje de Cables",
    cableDesc: "Servicios completos de ensamblaje de cables desde el diseño hasta la producción",
    qualityControl: "Control de Calidad",
    qualityDesc: "Procesos rigurosos de prueba e inspección para garantizar la confiabilidad del producto",
    rapidPrototyping: "Prototipado Rápido",
    prototypeDesc: "Servicios de prototipado rápido para acelerar el desarrollo de su producto",
    supplyChain: "Soluciones de Cadena de Suministro",
    supplyDesc: "Gestión integral de la cadena de suministro para optimizar su proceso de adquisición",
    valueAdded: "Servicios de Valor Agregado",
    valueAddedDesc: "Servicios adicionales incluyendo kitting, etiquetado y embalaje",
    process: "Nuestro Proceso",
    consultation: "Consulta",
    consultationDesc: "Trabajamos con usted para entender sus requisitos y objetivos",
    design: "Diseño",
    designDesc: "Nuestros ingenieros crean diseños y especificaciones detalladas",
    prototyping: "Prototipado",
    prototypingDesc: "Construimos prototipos para pruebas y validación",
    production: "Producción",
    productionDesc: "Producción a gran escala con control de calidad estricto",
    delivery: "Entrega",
    deliveryDesc: "Entrega oportuna según sus especificaciones",
    support: "Soporte",
    supportDesc: "Soporte técnico continuo y servicio",
    fastDelivery: "Entrega Rápida",
    quickTurnaround: "Rápida Entrega",
    completeProduction: "Producción Completa",
    customSolutions: "Soluciones Personalizadas",
    tailoredDesigns: "Diseños a Medida",
    qualityGuarantee: "Garantía de Calidad",
    testedProducts: "Productos Probados",
    
    // Industries Page
    industriesServed: "Industrias Atendidas",
    diverseApplications: "Sirviendo industrias diversas con soluciones de conectores especializadas",
    automotive: "Automotriz",
    automotiveText: "Conectores para control de motor, infoentretenimiento, sistemas de seguridad y aplicaciones EV",
    medical: "Médica",
    medicalText: "Conectores de precisión para equipos de diagnóstico, monitoreo de pacientes e instrumentos quirúrgicos",
    industrial: "Industrial",
    industrialText: "Conectores robustos para automatización, robótica y sistemas de control de procesos",
    consumer: "Electrónica de Consumo",
    consumerText: "Conectores miniatura para smartphones, tablets, dispositivos wearables y electrodomésticos inteligentes",
    dataCenters: "Centros de Datos",
    dataCentersText: "Conectores de alta velocidad para servidores, matrices de almacenamiento y equipos de red",
    energy: "Energía y Servicios Públicos",
    energyText: "Conectores para sistemas solares, almacenamiento de baterías e infraestructura de red",
    aerospace: "Aeroespacial y Defensa",
    aerospaceText: "Conectores de alta confiabilidad para aplicaciones de aviación y defensa",
    telecommunications: "Telecomunicaciones",
    telecommunicationsText: "Conectores para estaciones base, redes de fibra óptica e infraestructura 5G",
    whyChooseIndustries: "Por Qué Elegirnos para Su Industria",
    industryExpertise: "Experiencia en la Industria",
    expertiseText: "Comprensión profunda de los requisitos y estándares específicos de la industria",
    customizedSolutions: "Soluciones Personalizadas",
    customizedText: "Productos adaptados para satisfacer desafíos únicos de aplicaciones",
    compliance: "Cumplimiento",
    complianceText: "Adherencia a estándares y certificaciones de la industria",
    globalSupport: "Soporte Global",
    globalText: "Soporte y servicio mundial para clientes internacionales",
    
    // Additional Industries Page Keys
    vehicleSystems: "Conectores para sistemas críticos de vehículos",
    engineControl: "Unidades de Control de Motor (ECUs)",
    infotainment: "Sistemas de Infoentretenimiento",
    safetyADAS: "Sistemas de Seguridad y ADAS",
    electricVehicle: "Sistemas de Vehículos Eléctricos (EV)",
    powertrain: "Sistemas de Control de Transmisión",
    automotiveApplications: "Gestión de motor, infoentretenimiento, sistemas de seguridad, gestión de baterías EV y tecnologías de conducción autónoma",
    medicalDevices: "Dispositivos Médicos",
    highReliability: "Conectores de precisión de alta confiabilidad",
    patientMonitoring: "Equipos de Monitoreo de Pacientes",
    diagnosticEquipment: "Sistemas de Imagen Diagnóstica",
    surgicalInstruments: "Instrumentos Quirúrgicos y de Mínima Invasión",
    imagingSystems: "Sistemas MRI, CT y Ultrasonido",
    laboratoryEquipment: "Equipos de Automatización de Laboratorio",
    medicalApplications: "Monitoreo de pacientes, imagen diagnóstica, instrumentos quirúrgicos, automatización de laboratorio y dispositivos de telemedicina",
    industrialAutomation: "Automatización Industrial",
    controlMonitoring: "Sistemas de control y monitoreo",
    plcSystems: "Controladores Lógicos Programables (PLCs)",
    robotics: "Robótica Industrial",
    sensorsActuators: "Sensores y Actuadores",
    industrialNetworking: "Redes Industriales",
    processControl: "Sistemas de Control de Procesos",
    industrialApplications: "Automatización de fábrica, robótica, control de procesos, sensores y aplicaciones de IoT industrial",
    energyStorage: "Almacenamiento de Energía",
    batteryManagement: "Sistemas de gestión de baterías",
    batteryPacks: "Conectores para Paquetes de Baterías",
    energyStorageCabinets: "Gabinetes de Almacenamiento de Energía",
    powerDistribution: "Unidades de Distribución de Energía",
    solarSystems: "Sistemas de Paneles Solares",
    upsSystems: "Sistemas UPS y Energía de Respaldo",
    energyApplications: "Instalaciones solares, sistemas de almacenamiento de baterías, infraestructura de red y soluciones de energía de respaldo",
    aviationDefense: "Sistemas de aviación y defensa",
    avionics: "Sistemas de Aviónica",
    flightControl: "Sistemas de Control de Vuelo",
    communicationSystems: "Sistemas de Comunicación",
    navigationEquipment: "Equipos de Navegación",
    defenseElectronics: "Electrónica de Defensa",
    aerospaceApplications: "Aviónica de aeronaves, controles de vuelo, sistemas de navegación, comunicaciones por satélite y electrónica de defensa",
    serverData: "Servidor y Centro de Datos",
    dataCenters: "Infraestructura de Centros de Datos",
    serverSystems: "Sistemas de Servidor",
    storageArrays: "Matrices de Almacenamiento",
    networkingEquipment: "Equipos de Redes",
    cloudInfrastructure: "Infraestructura en la Nube",
    serverApplications: "Computación de alto rendimiento, almacenamiento de datos, infraestructura de red y plataformas de computación en la nube",
    communicationInfrastructure: "Infraestructura de comunicaciones",
    fiveG: "Infraestructura de Red 5G",
    networkEquipment: "Equipos de Red",
    fiberOptic: "Conexiones de Fibra Óptica",
    wirelessSystems: "Sistemas de Comunicación Inalámbrica",
    satelliteCommunications: "Comunicaciones por Satélite",
    telecomApplications: "Estaciones base 5G, redes de fibra óptica, infraestructura inalámbrica y comunicaciones por satélite",
    personalDevices: "Dispositivos electrónicos personales",
    smartphones: "Smartphones",
    tablets: "Tablets",
    wearables: "Dispositivos Wearables",
    smartHome: "Dispositivos para el Hogar Inteligente",
    audioEquipment: "Equipos de Audio",
    consumerApplications: "Dispositivos móviles, tablets, wearables, productos para el hogar inteligente, consolas de juegos y equipos de audio",
    industriesDescription: "Explore cómo Qingshun Electronics proporciona soluciones especializadas de conectores en diversas industrias, incluyendo automotriz, médica, industrial, energía, aeroespacial, centros de datos, telecomunicaciones y electrónica de consumo.",
    providingReliable: "Proporcionando soluciones de conectores confiables y de alto rendimiento adaptadas a las demandas únicas de cada industria que atendemos.",
    keyApplications: "Aplicaciones Clave",
    solutionsWeProvide: "Soluciones que Ofrecemos",
    needSolutionsSpecificIndustry: "¿Necesita Soluciones para una Industria Específica?",
    engineeringTeam: "Nuestro equipo de ingeniería está listo para diseñar y fabricar soluciones de conectores personalizadas para sus requisitos específicos de la industria.",
    talkToExpert: "Hable con un Experto",
    industriesWeServe: "Industrias que Atendemos",
    
    // Manufacturing Page
    manufacturingProcess: "Proceso de Fabricación",
    inHouseCapabilities: "Capacidades completas de fabricación interna",
    injectionMolding: "Moldeo por Inyección",
    moldingDesc: "Moldeo por inyección avanzado para carcasa de conectores con tolerancias de precisión",
    stamping: "Estampado",
    stampingDesc: "Estampado de alta precisión para terminales y contactos de conectores",
    plating: "Revestimiento",
    platingDesc: "Acabado superficial con oro, estaño y otros recubrimientos especializados",
    assembly: "Ensamblaje",
    assemblyDesc: "Procesos de ensamblaje automatizados y manuales para soluciones completas de conectores",
    testing: "Pruebas",
    testingDesc: "Pruebas integrales incluyendo validación eléctrica, mecánica y ambiental",
    qualityAssurance: "Garantía de Calidad",
    assuranceDesc: "Control de calidad riguroso durante todo el proceso de fabricación",
    equipment: "Nuestro Equipo",
    equipmentText: "Equipos de fabricación de vanguardia para precisión y consistencia",
    moldingMachine: "Máquinas de Moldeo por Inyección",
    stampingPress: "Prensas de Estampado de Precisión",
    platingLine: "Líneas de Revestimiento Automatizadas",
    assemblyLine: "Líneas de Ensamblaje Automatizadas",
    testingEquipment: "Equipos de Prueba Avanzados",
    environmentalChamber: "Cámaras de Prueba Ambiental",
    productionCapacity: "Capacidad de Producción",
    capacityText: "Capacidades de producción de alto volumen para satisfacer su demanda",
    monthlyCapacity: "Capacidad de Producción Mensual",
    qualityControlProcess: "Proceso de Control de Calidad",
    controlProcess: "Nuestro proceso integral de control de calidad asegura la calidad constante del producto",
    incomingInspection: "Inspección de Material Entrante",
    incomingText: "Inspección exhaustiva de todas las materias primas y componentes",
    inProcess: "Controles de Calidad en Proceso",
    inProcessText: "Monitoreo continuo durante la fabricación",
    finalTesting: "Pruebas de Producto Final",
    finalText: "Pruebas integrales de productos terminados",
    documentation: "Documentación y Trazabilidad",
    documentationText: "Registros detallados para la trazabilidad completa del producto",
    
    // Blog Page
    ourBlog: "Nuestro Blog",
    insights: "Información sobre tecnología de conectores, tendencias de fabricación y noticias de la industria",
    stayUpdated: "Manténgase Actualizado con Nuestras Perspectivas",
    subscribe: "Suscríbase a nuestro boletín para las últimas publicaciones de blog y noticias de la industria",
    yourEmail: "Su dirección de correo electrónico",
    subscribeButton: "Suscribirse",
    
    // 404 Page
    pageNotFound: "Página No Encontrada",
    pageNotFoundText: "La página que busca no existe o ha sido movida. Volvamos al camino correcto.",
    quickNavigation: "Navegación Rápida",
    returnHome: "Volver al Inicio",
    browseProducts: "Navegar Productos",
    needHelp404: "¿Necesita Ayuda?",
    help404: "Si tiene problemas para encontrar lo que busca, nuestro equipo está aquí para ayudarle.",
    contactSupport: "Contactar Soporte",
    callUs: "Llámenos",
    errorReference: "Código de error: 404 - Página no encontrada",
    backToBusiness: "De vuelta a los negocios con Qingshun Electronics",
    goToPage: "Ir a la página",
    goBack: "Volver",
    goodMorning: "Buenos días",
    goodAfternoon: "Buenas tardes",
    goodEvening: "Buenas noches",
    didYouKnow: "¿Sabía Usted?",
    pageTip: "Intente verificar errores en la URL o use nuestra navegación arriba.",
    trustedBy: "Confiado por más de 1000 clientes globales desde 2011",
    
    // Theme Toggle
    switchToLight: "Cambiar a modo claro",
    switchToDark: "Cambiar a modo oscuro",
    
    // Contact Page
    needCustom: "¿Necesita una",
    connectorSolution: "solución de conector",
    engineeringTeam: "Nuestro equipo de ingeniería está listo para diseñar y fabricar soluciones de conectores personalizadas para sus requisitos específicos.",
    requestQuote: "Solicitar Cotización",
    viewAllServices: "Ver Todos los Servicios",
    
    // Missing keys for Services page
    connectorManufacturing: "Fabricación de Conectores",
    connectorManufacturingDesc: "Servicios completos de fabricación desde el diseño hasta la producción de conectores personalizados",
    customConnectorDesign: "Diseño e ingeniería de conectores personalizados",
    materialSelection: "Selección y abastecimiento de materiales",
    precisionManufacturing: "Fabricación de precisión con tolerancias ajustadas",
    qualityAssurance: "Pruebas integrales de garantía de calidad",
    stampingServices: "Servicios de Estampado",
    stampingServicesDesc: "Estampado de alta precisión para terminales y contactos de conectores",
    progressiveDie: "Estampado progresivo para piezas complejas",
    materialPlating: "Revestimiento de materiales y acabado superficial",
    tightTolerance: "Capacidades de estampado de tolerancia ajustada",
    volumeProduction: "Producciones de alto volumen",
    moldDevelopment: "Desarrollo de Moldes",
    moldDevelopmentDesc: "Diseño y desarrollo de moldes personalizados para carcasas de conectores",
    cadcadDesign: "Diseño y simulación CAD/CAE",
    moldFlow: "Análisis y optimización del flujo del molde",
    maintenanceRepair: "Servicios de mantenimiento y reparación de moldes",
    injectionMolding: "Moldeo por Inyección",
    injectionMoldingDesc: "Moldeo por inyección avanzado para carcasas de conectores",
    multiCavity: "Producción de moldes multi-cavidad",
    materialEngineering: "Ingeniería y selección de materiales",
    precisionTolerances: "Control de tolerancias de precisión",
    highVolume: "Capacidades de producción de alto volumen",
    cableAssembly: "Ensamblaje de Cables",
    cableAssemblyDesc: "Servicios completos de ensamblaje de cables desde el diseño hasta la producción",
    customWire: "Diseño de arnés de cables personalizado",
    connectorAssembly: "Ensamblaje y terminación de conectores",
    testingValidation: "Servicios de prueba y validación",
    ulCertification: "Soporte de certificación UL y otras",
    qualityControlDesc: "Control de calidad riguroso durante todo el proceso de fabricación",
    incomingInspection: "Inspección de material entrante",
    inProcessControl: "Control de calidad en proceso",
    finalTesting: "Pruebas y validación de producto final",
    documentationCertification: "Soporte de documentación y certificación",
    tooling: "Herramientas",
    toolingDesc: "Diseño y preparación de herramientas para la producción",
    testingDesc: "Pruebas y validación integral",
    servicesDescription: "Servicios completos de fabricación para conectores personalizados y ensamblajes de cables con garantía de calidad",
    electronicsManufacturing: "Fabricación de Electrónica",
    our: "Nuestros",
    comprehensiveServices: "Servicios de fabricación integrales adaptados a sus necesidades",
    fromConcept: "Desde el concepto hasta la finalización, aseguramos la calidad en cada paso",
    readyToStart: "¿Listo para comenzar su",
    project: "proyecto",
    contactUsDiscuss: "Contáctenos hoy para discutir sus requisitos de fabricación",
    getInTouch: "Ponerse en Contacto",
    
    // Missing keys for About page
    companyFounded: "Fundación de la Empresa",
    establishedSuzhou: "Establecida en Suzhou, China como fabricante especializado en conectores",
    internationalExpansion: "Expansión Internacional",
    firstExports: "Primeras exportaciones a los mercados europeos y norteamericanos",
    rohsCertification: "Certificación RoHS",
    achievedCompliance: "Logro de cumplimiento RoHS para estándares ambientales",
    thousandClients: "Más de 1,000 Clientes Globales",
    reachedMilestone: "Alcanzó el hito de servir a más de 1,000 clientes globales",
    advancedAutomation: "Automatización Avanzada",
    upgradedFacilities: "Instalaciones mejoradas con tecnología de automatización avanzada",
    globalLeader: "Líder Global",
    servingCountries: "Sirviendo a clientes en más de 8 países en todo el mundo",
    qualityFirst: "Calidad Primero",
    qualityFirstDesc: "Nunca comprometemos la calidad en ningún aspecto de nuestras operaciones",
    customerFocus: "Enfoque en el Cliente",
    customerFocusDesc: "Su éxito es nuestro éxito - trabajamos estrechamente con los clientes para satisfacer sus necesidades específicas",
    innovation: "Innovación",
    innovationDesc: "Mejorando constantemente nuestros productos y procesos a través de la innovación",
    globalReach: "Alcance Global",
    globalReachDesc: "Sirviendo a clientes en múltiples países con soporte localizado",
    yearsInBusiness: "Años en el Negocio",
    brandsReplaced: "Marcas Reemplazadas",
    annualProduction: "Producción Anual",
    qualityTested: "Calidad Probada",
    aboutDescription: "Conozca Qingshun Electronics, un fabricante líder de alternativas de conectores de alta calidad y ensamblajes de cables personalizados desde 2011.",
    aboutPageDescription: "Acerca de Qingshun Electronics - Fabricante líder de alternativas de conectores y ensamblajes de cables personalizados",
    leadingManufacturer: "Fabricante líder de alternativas de conectores de alta calidad y ensamblajes de cables personalizados",
    whoWeAre: "Quiénes Somos",
    weAre: "Somos",
    productsServe: "Nuestros productos sirven a diversas industrias, incluidas la automotriz, médica, industrial y electrónica de consumo con soluciones rentables.",
    factoryImageAlt: "Exterior de la instalación de fabricación de Qingshun Electronics",
    coreValues: "Valores Fundamentales",
    principlesGuide: "Los principios que guían nuestras operaciones comerciales y relaciones",
    ourJourney: "Nuestro Recorrido",
    journey: "Trayectoria",
    keyMilestones: "Hitos clave en el desarrollo y crecimiento de nuestra empresa",
    quality: "Calidad",
    certificationsQuality: "Certificaciones y Calidad",
    committedStandards: "Comprometidos con los más altos estándares de calidad y cumplimiento",
    
    // Missing keys for Contact page
    us: "Nosotros",
    contactDescription: "Contacte a Qingshun Electronics para cotizaciones de productos, servicios de fabricación personalizada, soporte técnico u oportunidades de asociación. Estamos listos para ayudarle con sus necesidades de conectores.",
    generalInquiry: "Consulta General",
    productQuote: "Solicitud de Cotización de Producto",
    customManufacturing: "Fabricación Personalizada",
    technicalSupport: "Soporte Técnico",
    partnershipOpportunity: "Oportunidad de Asociación",
    other: "Otro",
    messageSent: "¡Mensaje Enviado!",
    thankYouMessage: "Gracias por contactarnos. Nos pondremos en contacto con usted lo antes posible.",
    company: "Empresa",
    yourCompany: "Nombre de Su Empresa",
    selectSubject: "Seleccione un Asunto",
    howCanWeHelp: "¿Cómo podemos ayudarle?",
    attachment: "Adjunto",
    optional: "Opcional",
    chooseFile: "Elegir Archivo",
    maxFileSize: "Tamaño máximo de archivo: 10MB",
    companyInformation: "Información de la Empresa",
    address: "Dirección",
    businessHours: "Horario de Atención",
    businessHoursDetails: "Lunes - Viernes: 8:00 AM - 6:00 PM (GMT+8)",
    whyChooseQingshun: "Por Qué Elegir Qingshun",
    comparedToBrands: "en comparación con marcas premium",
    certifiedManufacturing: "fabricación certificada",
    yearsOfExperience: "años de experiencia",
    globalExport: "Capacidades de exportación global",
    contactToday: "¡Contáctenos hoy para una cotización gratuita!",
    
    // Missing keys from Home.js
    comprehensiveSolutions: "Soluciones integrales para sus necesidades de conectores",
    aboutOurCompany: "Acerca de Nuestra Empresa",
    isoCertified: "Certificado ISO 9001",
    rohsCompliant: "Cumple con RoHS",
    globalStandards: "Estándares Globales de Calidad",
    compatibleWith: "Compatible con más de 20 marcas principales",
    directReplacementsDesc: "Reemplazos directos para marcas premium con ahorros significativos",
    money: "Dinero",
    contactUsToday: "Contáctenos hoy para una cotización gratuita y vea cuánto puede ahorrar",
    
    // Missing keys from Products.js
    connectorSolutions: "Soluciones de Conectores",
    highSpeedData: "Transmisión de datos de alta velocidad",
    needCustomConnectorSolution: "¿Necesita una Solución de Conector Personalizada?",
    
    // Missing keys from Services.js
    ourServicesTitle: "Nuestros Servicios",
    service: "Servicio",
    ourProcessTitle: "Nuestro Proceso",
    readyToStartProject: "¿Listo para Comenzar su Proyecto?",
    
    // Missing keys from Manufacturing.js
    customPlastic: "Fabricación personalizada de carcasas de conectores de plástico",
    materialPA: "Materiales: PA66, PA6, PBT, LCP, PPS",
    tolerance: "Tolerancia: precisión de ±0.05mm",
    stampingWorkshop: "Taller de Estampado",
    precisionCopper: "Estampado de terminales de aleación de cobre de precisión",
    materialBrass: "Materiales: Latón, Bronce Fosforoso, Cobre Berilio",
    thickness: "Rango de espesor: 0.1mm - 3.0mm",
    inHouseMold: "Diseño y fabricación de moldes internos",
    cadcad: "Capacidades de diseño CAD/CAM/CAE",
    moldMaintenance: "Mantenimiento y reparación de moldes",
    cncMachining: "Mecanizado CNC",
    highPrecision: "Mecanizado de componentes de alta precisión",
    edm: "EDM (Mecanizado por Descarga Eléctrica)",
    wireCutting: "Corte y perfilado de alambre",
    cncMilling: "Fresado y torneado CNC",
    surfaceFinishing: "Acabado y pulido de superficies",
    assemblyLines: "Líneas de Ensamblaje",
    automatedConnector: "Sistemas automatizados de ensamblaje de conectores",
    semiAutomatic: "Líneas de ensamblaje semiautomáticas",
    fullyAutomatic: "Líneas de producción completamente automáticas",
    inlineTesting: "Pruebas en línea y control de calidad",
    cleanRoom: "Ambiente de ensamblaje en sala limpia",
    rohsCertified: "Procesos de control de calidad certificados RoHS",
    incomingMaterial: "Inspección de material entrante",
    finalProduct: "Pruebas de producto final",
    reliabilityTesting: "Pruebas ambientales y de confiabilidad",
    restrictionHazardous: "Restricción de Sustancias Peligrosas",
    qualityManagement: "Sistema de Gestión de Calidad",
    automotiveQuality: "Gestión de Calidad Automotriz",
    safetyCertification: "Certificación de Seguridad",
    designReview: "Revisión de Diseño",
    analyzeTechnical: "Analizar requisitos técnicos y especificaciones",
    createSamples: "Crear muestras para validación y pruebas",
    developMolds: "Desarrollar moldes y herramientas de producción",
    massProduction: "Producción en masa con control de calidad",
    comprehensiveInspection: "Inspección y pruebas exhaustivas",
    packagingShipping: "Embalaje y envío profesional",
    manufacturingCapabilities: "Capacidades de Fabricación",
    inHouseProduction: "Producción Interna",
    manufacturingDescription: "Capacidades completas de fabricación interna que incluyen moldeo por inyección, estampado, mecanizado CNC y ensamblaje con control de calidad estricto",
    completeInHouse: "Fabricación interna completa desde el diseño hasta la entrega",
    capabilities: "Capacidades",
    ourCoreCapabilities: "Nuestras Capacidades Principales",
    stateOfTheArt: "Instalaciones y equipos de última generación para fabricación de precisión",
    facility: "Instalación",
    ourManufacturingProcess: "Nuestro Proceso de Fabricación",
    industryCertifications: "Certificaciones de la Industria",
    readyToStartManufacturingProject: "¿Listo para Comenzar su Proyecto de Fabricación?",
  },
  no: {
    // SEO Meta Content
    seoTitle: "Premium Kontaktalternativer - Spar 50-70% på Kvalitetskontakter | Qingshun Electronics",
    seoDescription: "Ledende produsent av høykvalitets kontaktalternativer. Direkte erstatninger for TE, Molex, Amphenol, JST med 50-70% kostnadsbesparelse. ISO-sertifisert, samme kvalitetsstandarder.",
    seoKeywords: "kontaktalternativer, TE kontakt alternativ, Molex alternativ, Amphenol alternativ, bilkontakter, industrikontakter, kostnadsbesparelse, kvalitetskontakter",
    seoFaqQ1: "Hvor mye kan jeg spare på kontaktalternativer?",
    seoFaqA1: "Våre kunder sparer typisk 50-70% sammenlignet med store merker som TE, Molex og Amphenol, mens de opprettholder de samme kvalitetsstandardene.",
    seoFaqQ2: "Er kontaktene deres kompatible med store merker?",
    seoFaqA2: "Ja, våre kontakter er direkte erstatninger for over 20 store merker inkludert TE, Molex, Amphenol, JST og mer.",
    seoFaqQ3: "Hvilke bransjer betjener dere?",
    seoFaqA3: "Vi betjener bil-, industri-, medisinsk-, forbrukerelektronikk- og telekommunikasjonsbransjen med sertifiserte kontaktløsninger.",

    // Navigation
    home: "Hjem",
    about: "Om oss",
    services: "Tjenester",
    products: "Produkter",
    industries: "Bransjer",
    manufacturing: "Produksjon",
    blog: "Blogg",
    contact: "Kontakt",
    admin: "Admin",

    // Hero Section
    premiumConnectorAlternatives: "Spar 50–70% på Premium Kontaktalternativer",
    qualitySolutions: "ISO-sertifiserte alternativer til TE, Molex, Amphenol, JST og 20+ store merker. Samme spesifikasjoner. En brøkdel av kostnaden. Betrodd av 1 000+ ingeniører i 8+ land.",
    getAQuote: "Få et tilbud",
    viewProducts: "Se produkter",
    directReplacements: "Direkte erstatninger for 20+ store merker",
    notYourBrand: "Finner du ikke merkevaren din? Vi tilbyr tilpassede løsninger for alle kontaktmerker.",

    // Cost Comparison
    savePercentage: "Spar 50-70% uten å kompromittere kvaliteten",
    sameSpecifications: "Samme spesifikasjoner, samme ytelse, betydelig lavere kostnad",
    originalBrand: "Originalmerke",
    qingshunAlternative: "Qingshun-alternativ",
    whyCostLess: "Hvorfor våre alternativer koster mindre",
    verticalIntegration: "Vertikal integrasjon",
    directSales: "Direkte salgsmodell",
    efficientManufacturing: "Effektiv produksjon",
    noPremiumMarkup: "Ingen premiumtillegg",
    costSavings: "Kostnadsbesparelse",
    seeOurProducts: "Se våre produkter",
    competitivePricing: "Vår konkurransedyktige prissetting kommer fra effektive prosesser og direkte salg",
    significantSavings: "Betydelige kostnadsbesparelser",
    costSavingsDesc: "Opplev 50-70% besparelse uten å kompromittere kvalitet eller ytelse",
    verticalIntegrationDesc: "Kontroll over hele produksjonskjeden reduserer kostnader",
    efficientManufacturingDesc: "Moderne automatisering og optimaliserte prosesser",
    directSalesDesc: "Eliminering av mellomledd gir besparelsene videre til deg",
    noPremiumMarkupDesc: "Ingen merkevarepremie eller lisensavgifter",

    // Stats
    yearsExperience: "Års erfaring",
    globalClients: "Globale kunder",
    countriesServed: "Land betjent",
    costSavingsStats: "Kostnadsbesparelse",

    // Brand Replacement
    replacingBrands: "Erstatter store merker",
    alternativesPremium: "Direkte alternativer til premium kontaktmerker med betydelige kostnadsbesparelser",
    cantFindBrand: "Finner du ikke merkevaren din?",
    alternativesAnyBrand: "Vi kan lage alternativer for nesten alle kontaktmerker. Kontakt oss med ditt delenummer for et tilpasset tilbud.",
    requestCustom: "for tilpassede løsninger",

    // About Section
    yourTrustedPartner: "Din pålitelige kontaktpartner",
    companyDescription1: "Suzhou Qingshun Electronics Technology Co., Ltd. produserer drop-in-erstatninger for kontakter fra TE, Molex, Amphenol, JST og 20+ andre ledende merker — til 50–70% lavere kostnad. ISO 9001-sertifisert siden 2017, leverer vi de samme spesifikasjonene og ytelsen designene dine krever.",
    companyDescription2: "Grunnlagt i 2011 med en fullt vertikalt integrert fabrikk i Suzhou, Kina — som dekker sprøytestøping, presisjonstermaling, belegging og endelig montering under ett tak. Denne ende-til-ende-kontrollen holder kvaliteten høy og marginene lave, slik at besparelsene går direkte til deg.",
    learnMore: "Lær mer om oss",

    // CTA
    readyToSave: "Klar til å spare 50-70% på kontakter?",
    freeQuote: "Kontakt oss i dag for et gratis tilbud og oppdag hvordan våre premium-alternativer kan redusere kostnadene dine",
    getYourQuote: "Få ditt tilbud",
    ourServices: "Våre tjenester",

    // Footer
    contactInfo: "Kontaktinformasjon",
    factoryAddress: "Huayuan Road 2526, Zhangpu Town, Kunshan City, Suzhou, Jiangsu, Kina",
    phone: "Telefon",
    wechat: "WeChat",
    whatsapp: "WhatsApp",
    email: "E-post",
    quickLinks: "Hurtiglenker",
    allRights: "Alle rettigheter forbeholdt.",
    exportMarkets: "Global eksport",
    privacyPolicy: "Personvernpolicy",
    termsOfService: "Tjenestevilkår",
    sitemap: "Nettstedskart",
    globalExport: "Global eksport",
    worldwideShipping: "Verdensomspennende frakt med lokal støtte",
    servingClients: "Betjener kunder i 8+ land over hele verden",
    worldwide: "Verdensomspennende",

    // Contact Page
    contactUs: "Kontakt oss",
    getInTouch: "Ta kontakt med teamet vårt",
    sendMessage: "Send melding",
    yourName: "Ditt navn",
    yourEmail: "Din e-post",
    subject: "Emne",
    message: "Melding",
    send: "Send",

    // Products Page
    ourProducts: "Våre produkter",
    highQualityAlternatives: "Høykvalitets kontaktalternativer for ulike applikasjoner",
    automotiveConnectors: "Bilkontakter",
    automotiveDesc: "Høypålitelige kontakter for kjøretøysystemer",
    medicalConnectors: "Medisinske kontakter",
    medicalDesc: "Presisjonskontakter for medisinsk utstyr",
    industrialConnectors: "Industrikontakter",
    industrialDesc: "Robuste kontakter for tøffe miljøer",
    consumerElectronics: "Forbrukerelektronikk",
    consumerDesc: "Miniatyrskontakter for bærbare enheter",
    dataServer: "Data og server",
    dataDesc: "Høyhastighetskontakter for datasenter",
    energyStorage: "Energilagring",
    energyDesc: "Kontakter for batterisystemer",
    brandsWeReplace: "Merker vi erstatter",
    costEffective: "Kostnadseffektive alternativer til premium kontaktmerker - Spar 50-70% uten å gå på kompromiss med kvaliteten",
    needSpecific: "Trenger du et spesifikt merkealternativ?",
    alternativesAny: "Vi kan lage alternativer for nesten alle kontaktmerker. Kontakt oss med ditt delenummer for et tilpasset tilbud.",
    requestCustomAlternative: "Be om tilpasset alternativ",
    productResources: "Produktressurser",
    downloadTechnical: "Last ned teknisk dokumentasjon og spesifikasjoner",
    catalog: "Katalog",
    comprehensiveCatalog: "Omfattende produktkatalog med spesifikasjoner og dimensjoner",
    downloadPDF: "Last ned PDF",
    datasheets: "Datablader",
    technicalDatasheets: "Tekniske datablader for alle våre kontaktserier",
    needHelp: "Trenger du hjelp til å velge riktig produkt?",
    technicalTeam: "Vårt tekniske team er klar til å hjelpe deg med produktvalg og tilpasning",
    contactTechnical: "Kontakt teknisk støtte",
    customSolutions: "Tilpassede løsninger",

    // Products Page - Additional Keys
    boardToBoard: "Brett-til-brett",
    highDensity: "Høytetthetskontakter for kompakt elektronikk",
    pitchRange: "0,5 mm til 2,54 mm delingsområde",
    highSpeed: "Støtte for høyhastighets dataoverføring",
    lowProfile: "Lavprofildesign for plassbegrensede applikasjoner",
    dualRow: "To-rads konfigurasjoner for økt kretstettet",
    wireToBoard: "Ledning-til-brett",
    reliableConnections: "Pålitelige forbindelser mellom ledninger og PCB-er",
    singleDouble: "Enkelt- og to-rads konfigurasjoner",
    lockingMechanism: "Låsemekanismer for sikker tilkobling",
    multipleWires: "Flere ledningsavslutningsalternativer",
    colorCoding: "Fargekoding for enkel identifikasjon",
    wireToWire: "Ledning-til-ledning",
    flexibleSolutions: "Fleksible løsninger for ledningsforbindelser",
    crimpTerminal: "Krimpterminaltilkoblinger",
    insulationDisplacement: "Isolasjonsbortrensingsteknologi",
    multipleCircuits: "Flere kretser i enkeltskontakter",
    environmentalProtection: "Miljøvernvurderinger",
    usbConnectors: "USB-kontakter",
    universalConnectivity: "Universelle tilkoblingsløsninger",
    usbTypes: "USB Type-A, Type-B, Type-C varianter",
    powerDelivery: "Strømleveranse opptil 100W",
    reversibleDesign: "Reversible kontaktdesign",
    rfCoaxial: "RF og koaksial",
    highFrequency: "Høyfrekvent signaloverføring",
    impedanceControl: "Presisjons impedanskontroll",
    lowInsertion: "Lave innsettingstap-egenskaper",
    excellentShielding: "Utmerket elektromagnetisk skjerming",
    multipleFrequencies: "Støtte for flere frekvensområder",
    automotive: "Bil",
    harshEnvironment: "Kontakter for tøffe miljøer",
    vibrationResistant: "Vibrasjonsbestandige design",
    temperatureRange: "-40°C til +125°C driftstemperaturområde",
    sealedHousings: "Forseglede hus for fuktighetsbeskyttelse",
    automotiveStandards: "I samsvar med bildestandarder",
    medical: "Medisinsk",
    precisionReliability: "Presisjon og pålitelighet for medisinske enheter",
    biocompatible: "Biokompatible materialer tilgjengelig",
    sterilizable: "Steriliserbare kontaktdesign",
    lowNoise: "Lav støy-ytelse",
    miniaturized: "Miniaturiserte formfaktorer",
    industrial: "Industri",
    ruggedDurable: "Robuste og holdbare løsninger",
    highCurrent: "Høy strømbærende kapasitet",
    ipRated: "IP-klassifisert for støv- og vannbeskyttelse",
    corrosionResistant: "Korrosjonsbestandige materialer",
    extendedTemperature: "Utvidet temperaturområde drift",
    dataCenter: "Datasenter",
    highPerformance: "Høy-ytelse datakontakter",
    lowLatency: "Ultra-lav latenstid overføring",
    powerEfficient: "Energieffektive design",
    rackMountable: "Rackmonterbare løsninger",
    connector: "Kontakt",
    comprehensiveRange: "Omfattende utvalg av kontaktløsninger",
    connectorProducts: "Kontaktprodukter",
    connectors: "Kontakter",
    productsDescription: "Utforsk vårt omfattende utvalg av høykvalitets kontaktalternativer for ulike applikasjoner",

    // About Page
    aboutUs: "Om oss",
    companyOverview: "Selskapsoversikt",
    established: "Etablert i 2011 har Qingshun Electronics vokst til å bli en ledende produsent av høykvalitets kontaktalternativer.",
    ourMission: "Vårt oppdrag",
    missionText: "Å levere kostnadseffektive, høykvalitets kontaktløsninger som hjelper kundene våre å redusere kostnader uten å kompromittere ytelse.",
    ourVision: "Vår visjon",
    visionText: "Å bli den globale lederen innen kontaktalternativer, anerkjent for vår innovasjon, kvalitet og kundeservice.",
    ourValues: "Våre verdier",
    value1: "Kvalitet først - Vi kompromitterer aldri på kvalitet",
    value2: "Kundefokus - Din suksess er vår suksess",
    value3: "Innovasjon - Konstant forbedring av våre produkter og prosesser",
    value4: "Integritet - Ærlig og transparent i alle våre handler",
    facilities: "Våre anlegg",
    facility1: "1 400 m² produksjonsanlegg",
    facility2: "Avansert sprøytestøpingsutstyr",
    facility3: "Presisjonstermalingspressen",
    facility4: "Automatiserte monteringslinjer",
    certifications: "Sertifiseringer",
    certified: "Vi er sertifisert i henhold til internasjonale standarder for kvalitets- og miljøstyring.",
    iso9001: "ISO 9001:2015 Kvalitetsstyring",
    iso14001: "ISO 14001:2015 Miljøstyring",
    rohs: "RoHS-overholdelse",
    reach: "REACH-overholdelse",
    meetOurTeam: "Møt teamet vårt",
    tonyChen: "Tony Chen",
    tonyTitle: "Grunnlegger og administrerende direktør",
    tonyBio: "Med over 15 års erfaring i elektronikindustrien leder Tony selskapet vårt med visjon og ekspertise.",
    sarahJohnson: "Sarah Johnson",
    sarahTitle: "Teknisk direktør",
    sarahBio: "Sarah overvåker våre tekniske operasjoner og produktutvikling med over 12 års ingeniørerfaring.",
    michaelWong: "Michael Wong",
    michaelTitle: "Driftssjef",
    michaelBio: "Michael sikrer at produksjonsprosessene våre kjører effektivt og oppfyller de høyeste kvalitetsstandardene.",

    // Services Page
    ourServices: "Våre tjenester",
    comprehensiveOfferings: "Omfattende produksjonstjenester tilpasset dine behov",
    connectorReplacement: "Kontakterstatning",
    replacementDesc: "Direkte alternativer til premium kontaktmerker med betydelige kostnadsbesparelser",
    customManufacturing: "Tilpasset produksjon",
    customDesc: "Skreddersydde kontaktløsninger designet og produsert etter dine eksakte spesifikasjoner",
    cableAssembly: "Kabelmontering",
    cableDesc: "Komplette kabelmonteringstjenester fra design til produksjon",
    qualityControl: "Kvalitetskontroll",
    qualityDesc: "Strenge teste- og inspeksjonsprosesser for å sikre produktpålitelighet",
    rapidPrototyping: "Rask prototyping",
    prototypeDesc: "Rask gjennomløpstid for prototypeytjenester for å akselerere produktutviklingen din",
    supplyChain: "Forsyningskjedeløsninger",
    supplyDesc: "Ende-til-ende forsyningskjedestyring for å optimalisere innkjøpsprosessen din",
    valueAdded: "Verdiskapende tjenester",
    valueAddedDesc: "Tilleggstjenester inkludert kitting, merking og emballasje",
    process: "Vår prosess",
    consultation: "Konsultasjon",
    consultationDesc: "Vi samarbeider med deg for å forstå dine krav og mål",
    design: "Design",
    designDesc: "Ingeniørene våre lager detaljerte design og spesifikasjoner",
    prototyping: "Prototyping",
    prototypingDesc: "Vi bygger prototyper for testing og validering",
    production: "Produksjon",
    productionDesc: "Fullskala produksjon med streng kvalitetskontroll",
    delivery: "Levering",
    deliveryDesc: "Rettidig levering etter dine spesifikasjoner",
    support: "Støtte",
    supportDesc: "Løpende teknisk støtte og service",
    fastDelivery: "Rask levering",
    quickTurnaround: "Rask gjennomløpstid",
    completeProduction: "Fullstendig produksjon",
    tailoredDesigns: "Skreddersydde design",
    qualityGuarantee: "Kvalitetsgaranti",
    testedProducts: "Testede produkter",

    // Industries Page
    industriesServed: "Bransjer vi betjener",
    diverseApplications: "Betjener ulike bransjer med spesialiserte kontaktløsninger",
    automotiveText: "Kontakter for motorkontroll, infotainment, sikkerhetssystemer og EV-applikasjoner",
    medicalText: "Presisjonskontakter for diagnostisk utstyr, pasientovervåking og kirurgiske instrumenter",
    industrialText: "Robuste kontakter for automatisering, robotikk og prosesskontrollsystemer",
    consumer: "Forbrukerelektronikk",
    consumerText: "Miniatyrskontakter for smarttelefoner, nettbrett, wearables og smarthusenheter",
    dataCenters: "Datasentre",
    dataCentersText: "Høyhastighetskontakter for servere, lagringsarrayer og nettverksutstyr",
    energy: "Energi og verktøy",
    energyText: "Kontakter for solsystemer, batterilagring og nettinfrastruktur",
    aerospace: "Aerospace og forsvar",
    aerospaceText: "Høypålitelige kontakter for avionikk og forsvarsapplikasjoner",
    telecommunications: "Telekommunikasjon",
    telecommunicationsText: "Kontakter for basestasjoner, fiberoptiske nettverk og 5G-infrastruktur",
    whyChooseIndustries: "Hvorfor velge oss for din bransje",
    industryExpertise: "Bransjekompetanse",
    expertiseText: "Dyp forståelse av bransjespesifikke krav og standarder",
    customizedSolutions: "Tilpassede løsninger",
    customizedText: "Skreddersydde produkter for å møte unike applikasjonsutfordringer",
    compliance: "Overholdelse",
    complianceText: "Overholdelse av bransjestandarder og sertifiseringer",
    globalSupport: "Global støtte",
    globalText: "Verdensomspennende støtte og service for internasjonale kunder",
    vehicleSystems: "Kontakter for kritiske kjøretøysystemer",
    engineControl: "Motorstyringsenheter (ECU-er)",
    infotainment: "Infotainmentsystemer",
    safetyADAS: "Sikkerhets- og ADAS-systemer",
    electricVehicle: "Elektriske kjøretøy (EV)-systemer",
    powertrain: "Drivlinjekontrollsystemer",
    automotiveApplications: "Motorstyring, infotainment, sikkerhetssystemer, EV-batteristyring og autonome kjøretøyteknologier",
    medicalDevices: "Medisinske enheter",
    highReliability: "Høypålitelige presisjonskontakter",
    patientMonitoring: "Pasientovervåkingsutstyr",
    diagnosticEquipment: "Diagnostiske bildesystemer",
    surgicalInstruments: "Kirurgiske og minimalt invasive instrumenter",
    imagingSystems: "MRI-, CT- og ultralydssystemer",
    laboratoryEquipment: "Laboratorieautomatiseringsutstyr",
    medicalApplications: "Pasientovervåking, diagnostisk bildebehandling, kirurgiske instrumenter, laboratorieautomatisering og telemedisinenheter",
    industrialAutomation: "Industriell automatisering",
    controlMonitoring: "Kontroll og overvåkingssystemer",
    plcSystems: "Programmerbare logiske kontrollere (PLC-er)",
    robotics: "Industriell robotikk",
    sensorsActuators: "Sensorer og aktuatorer",
    industrialNetworking: "Industrielt nettverk",
    processControl: "Prosesskontrollsystemer",
    industrialApplications: "Fabrikkaautomatisering, robotikk, prosesskontroll, sensorer og industrielle IoT-applikasjoner",
    batteryManagement: "Batteristyringssystemer",
    batteryPacks: "Batteripakkekontakter",
    energyStorageCabinets: "Energilagringsskap",
    powerDistribution: "Strømdistribusjonsenheter",
    solarSystems: "Solanleggssystemer",
    upsSystems: "UPS og backup-strømsystemer",
    energyApplications: "Solarinstallasjoner, batterilagringssystemer, nettinfrastruktur og backup-strømløsninger",
    aviationDefense: "Luftfart og forsvarssystemer",
    avionics: "Avionikksystemer",
    flightControl: "Flykontrollsystemer",
    communicationSystems: "Kommunikasjonssystemer",
    navigationEquipment: "Navigasjonsutstyr",
    defenseElectronics: "Forsvarselectronikk",
    aerospaceApplications: "Luftfartavionikk, flykontroller, navigasjonssystemer, satellittkommunikasjon og forsvarselektronikk",
    serverData: "Server og datasenter",
    serverSystems: "Serversystemer",
    storageArrays: "Lagringsarrayer",
    networkingEquipment: "Nettverksutstyr",
    cloudInfrastructure: "Skyinfrastruktur",
    serverApplications: "Høy-ytelse databehandling, datalagring, nettverksinfrastruktur og skyplattformer",
    communicationInfrastructure: "Kommunikasjonsinfrastruktur",
    fiveG: "5G Nettverksinfrastruktur",
    networkEquipment: "Nettverksutstyr",
    fiberOptic: "Fiberoptiske tilkoblinger",
    wirelessSystems: "Trådløse kommunikasjonssystemer",
    satelliteCommunications: "Satellittkommunikasjon",
    telecomApplications: "5G-basestasjoner, fiberoptiske nettverk, trådløs infrastruktur og satellittkommunikasjon",
    personalDevices: "Personlige elektroniske enheter",
    smartphones: "Smarttelefoner",
    tablets: "Nettbrett",
    wearables: "Wearables",
    smartHome: "Smarthusenheter",
    audioEquipment: "Lydutstyr",
    consumerApplications: "Mobilenheter, nettbrett, wearables, smarthusprodukter, spillkonsoller og lydutstyr",
    industriesDescription: "Utforsk hvordan Qingshun Electronics leverer spesialiserte kontaktløsninger på tvers av ulike bransjer inkludert bil, medisinsk, industri, energi, aerospace, datasentre, telekommunikasjon og forbrukerelektronikk.",
    providingReliable: "Leverer pålitelige, høy-ytelse kontaktløsninger tilpasset de unike kravene i hver bransje vi betjener.",
    keyApplications: "Nøkkelapplikasjoner",
    solutionsWeProvide: "Løsninger vi tilbyr",
    needSolutionsSpecificIndustry: "Trenger du løsninger for en spesifikk bransje?",
    engineeringTeam: "Ingeniørteamet vårt er klar til å designe og produsere tilpassede kontaktløsninger for dine bransjespesifikke krav.",
    talkToExpert: "Snakk med en ekspert",
    industriesWeServe: "Bransjer vi betjener",

    // Manufacturing Page
    manufacturingProcess: "Produksjonsprosess",
    inHouseCapabilities: "Komplette interne produksjonskapasiteter",
    injectionMolding: "Sprøytestøping",
    moldingDesc: "Avansert sprøytestøping for kontakthus med presisjonsmarginer",
    stamping: "Terming",
    stampingDesc: "Høy-presisjonen terming for kontaktterminaler og -kontakter",
    plating: "Belegging",
    platingDesc: "Overflatebehandling med gull, tinn og andre spesialbelagte belegg",
    assembly: "Montering",
    assemblyDesc: "Automatiserte og manuelle monteringsprosesser for komplette kontaktløsninger",
    testing: "Testing",
    testingDesc: "Omfattende testing inkludert elektrisk, mekanisk og miljøvalidering",
    qualityAssurance: "Kvalitetssikring",
    assuranceDesc: "Streng kvalitetskontroll gjennom hele produksjonsprosessen",
    equipment: "Vårt utstyr",
    equipmentText: "Toppmoderne produksjonsutstyr for presisjon og konsistens",
    moldingMachine: "Sprøytestøpingsmaskiner",
    stampingPress: "Presisjonstermingspressen",
    platingLine: "Automatiserte belegglinjer",
    assemblyLine: "Automatiserte monteringslinjer",
    testingEquipment: "Avansert testingsutstyr",
    environmentalChamber: "Miljøtestkammer",
    productionCapacity: "Produksjonskapasitet",
    capacityText: "Høyvolumsproduktionskapasitet for å møte ditt behov",
    monthlyCapacity: "Månedlig produksjonskapasitet",
    qualityControlProcess: "Kvalitetskontrollprosess",
    controlProcess: "Vår omfattende kvalitetskontrollprosess sikrer konsistent produktkvalitet",
    incomingInspection: "Innkommende materialinspeksjon",
    incomingText: "Grundig inspeksjon av alle råmaterialer og komponenter",
    inProcess: "Kvalitetskontroller under prosessen",
    inProcessText: "Kontinuerlig overvåking under produksjonen",
    finalTesting: "Endelig produkttest",
    finalText: "Omfattende testing av ferdige produkter",
    documentation: "Dokumentasjon og sporbarhet",
    documentationText: "Detaljerte registreringer for full produktsporbarhet",

    // Blog Page
    ourBlog: "Bloggen vår",
    insights: "Innsikter om kontaktteknologi, produksjonstrender og bransjenytt",
    stayUpdated: "Hold deg oppdatert med innsiktene våre",
    subscribe: "Abonner på nyhetsbrevet vårt for de siste blogginnleggene og bransjenytt",
    subscribeButton: "Abonner",

    // 404 Page
    pageNotFound: "Side ikke funnet",
    pageNotFoundText: "Siden du leter etter eksisterer ikke eller har blitt flyttet. La oss få deg tilbake på rett spor.",
    quickNavigation: "Rask navigasjon",
    returnHome: "Tilbake til hjemmesiden",
    browseProducts: "Bla gjennom produkter",
    needHelp404: "Trenger du hjelp?",
    help404: "Hvis du har problemer med å finne det du leter etter, er teamet vårt her for å hjelpe.",
    contactSupport: "Kontakt støtte",
    callUs: "Ring oss",
    errorReference: "Feilkode: 404 - Side ikke funnet",
    backToBusiness: "Tilbake til forretninger med Qingshun Electronics",
    goToPage: "Gå til side",
    goBack: "Gå tilbake",
    goodMorning: "God morgen",
    goodAfternoon: "God ettermiddag",
    goodEvening: "God kveld",
    didYouKnow: "Visste du?",
    pageTip: "Prøv å sjekke URL-en for feil eller bruk navigasjonen vår ovenfor.",
    trustedBy: "Betrodd av 1000+ globale kunder siden 2011",

    // Theme Toggle
    switchToLight: "Bytt til lys modus",
    switchToDark: "Bytt til mørk modus",

    // Contact Page
    needCustom: "Trenger du en tilpasset",
    connectorSolution: "kontaktløsning",
    requestQuote: "Be om tilbud",
    viewAllServices: "Se alle tjenester",

    // Services Page - Missing Keys
    connectorManufacturing: "Kontaktproduksjon",
    connectorManufacturingDesc: "Komplette produksjonstjenester fra design til produksjon av tilpassede kontakter",
    customConnectorDesign: "Tilpasset kontaktdesign og ingeniørarbeid",
    materialSelection: "Materialvalg og innkjøp",
    precisionManufacturing: "Presisjonsproduksjon med trange toleranser",
    stampingServices: "Termingstjenester",
    stampingServicesDesc: "Høy-presisjonen terming for kontaktterminaler og -kontakter",
    progressiveDie: "Progressiv die-terming for komplekse deler",
    materialPlating: "Materialbelegging og overflatebehandling",
    tightTolerance: "Trang toleranse termingskapasiteter",
    volumeProduction: "Høyvolumsproduktionskjøringer",
    moldDevelopment: "Formutvikling",
    moldDevelopmentDesc: "Tilpasset formdesign og utvikling for kontakthus",
    cadcadDesign: "CAD/CAE design og simulering",
    moldFlow: "Formflytanalyse og optimalisering",
    maintenanceRepair: "Formvedlikehold og reparasjonstjenester",
    injectionMoldingDesc: "Avansert sprøytestøping for kontakthus",
    multiCavity: "Flerkavitetsformproduksjon",
    materialEngineering: "Materialingeniørarbeid og valg",
    precisionTolerances: "Presisjonstoleranskontroll",
    highVolume: "Høyvolumsproduktionskraftig",
    cableAssemblyDesc: "Komplette kabelmonteringstjenester fra design til produksjon",
    customWire: "Tilpasset ledningsharness-design",
    connectorAssembly: "Kontaktmontering og avslutning",
    testingValidation: "Testing og valideringstjenester",
    ulCertification: "UL og andre sertifiseringsstøtte",
    qualityControlDesc: "Streng kvalitetskontroll gjennom produksjonsprosessen",
    incomingMaterial: "Innkommende materialinspeksjon",
    inProcessControl: "Kvalitetskontroll under prosessen",
    finalProduct: "Endelig produkttest og validering",
    documentationCertification: "Dokumentasjon og sertifiseringsstøtte",
    tooling: "Verktøy",
    toolingDesc: "Verktøydesign og forberedelse for produksjon",
    servicesDescription: "Komplette produksjonstjenester for tilpassede kontakter og kabelmontering med kvalitetssikring",
    electronicsManufacturing: "Elektronikkproduksjon",
    our: "Vår",
    comprehensiveServices: "Omfattende produksjonstjenester tilpasset dine behov",
    fromConcept: "Fra konsept til ferdigstillelse sikrer vi kvalitet i hvert trinn",
    readyToStart: "Klar til å starte ditt",
    project: "prosjekt",
    contactUsDiscuss: "Kontakt oss i dag for å diskutere dine produksjonskrav",

    // About Page - Missing Keys
    companyFounded: "Selskapet grunnlagt",
    establishedSuzhou: "Etablert i Suzhou, Kina som en spesialisert kontaktprodusent",
    internationalExpansion: "Internasjonal ekspansjon",
    firstExports: "Første eksport til europeiske og nordamerikanske markeder",
    rohsCertification: "RoHS-sertifisering",
    achievedCompliance: "Oppnådde RoHS-overholdelse for miljøstandarder",
    thousandClients: "1 000+ globale kunder",
    reachedMilestone: "Nådde milepælen med å betjene 1 000+ globale kunder",
    advancedAutomation: "Avansert automatisering",
    upgradedFacilities: "Oppgraderte anlegg med avansert automatiseringsteknologi",
    globalLeader: "Global leder",
    servingCountries: "Betjener kunder i 8+ land over hele verden",
    qualityFirst: "Kvalitet først",
    qualityFirstDesc: "Vi kompromitterer aldri på kvalitet i noen aspekter av virksomheten vår",
    customerFocus: "Kundefokus",
    customerFocusDesc: "Din suksess er vår suksess - vi samarbeider tett med kunder for å møte deres spesifikke behov",
    innovation: "Innovasjon",
    innovationDesc: "Konstant forbedring av våre produkter og prosesser gjennom innovasjon",
    globalReach: "Global rekkevidde",
    globalReachDesc: "Betjener kunder i flere land med lokal støtte",
    yearsInBusiness: "År i virksomhet",
    brandsReplaced: "Merker erstattet",
    annualProduction: "Årlig produksjon",
    qualityTested: "Kvalitetstestet",
    aboutDescription: "Lær om Qingshun Electronics, en ledende produsent av høykvalitets kontaktalternativer og tilpassede kabelmonteringer siden 2011.",
    aboutPageDescription: "Om Qingshun Electronics - Ledende produsent av kontaktalternativer og tilpassede kabelmonteringer",
    leadingManufacturer: "Ledende produsent av høykvalitets kontaktalternativer og tilpassede kabelmonteringer",
    whoWeAre: "Hvem vi er",
    weAre: "Vi er",
    productsServe: "Produktene våre betjener ulike bransjer inkludert bil, medisinsk, industri og forbrukerelektronikk med kostnadseffektive løsninger.",
    factoryImageAlt: "Qingshun Electronics produksjonsanlegg eksteriør",
    coreValues: "Kjerneverdier",
    principlesGuide: "Prinsippene som guider virksomheten og relasjonene våre",
    ourJourney: "Vår reise",
    journey: "Reise",
    keyMilestones: "Viktige milepæler i selskapets utvikling og vekst",
    quality: "Kvalitet",
    certificationsQuality: "Sertifiseringer og kvalitet",
    committedStandards: "Forpliktet til de høyeste standardene for kvalitet og overholdelse",

    // Contact Page - Missing Keys
    us: "oss",
    contactDescription: "Kontakt Qingshun Electronics for produkttilbud, tilpassede produksjonstjenester, teknisk støtte eller partnerskapsmuligheter. Vi er klare til å hjelpe med dine kontaktbehov.",
    generalInquiry: "Generelle henvendelser",
    productQuote: "Produkttilbudforespørsel",
    technicalSupport: "Teknisk støtte",
    partnershipOpportunity: "Partnerskapsmulighet",
    other: "Annet",
    messageSent: "Melding sendt!",
    thankYouMessage: "Takk for at du kontaktet oss. Vi kommer tilbake til deg så snart som mulig.",
    company: "Selskap",
    yourCompany: "Selskapsnavn",
    selectSubject: "Velg et emne",
    howCanWeHelp: "Hvordan kan vi hjelpe deg?",
    attachment: "Vedlegg",
    optional: "Valgfritt",
    chooseFile: "Velg fil",
    maxFileSize: "Maks filstørrelse: 10 MB",
    companyInformation: "Selskapsinformasjon",
    address: "Adresse",
    businessHours: "Åpningstider",
    businessHoursDetails: "Mandag - fredag: 08:00 - 18:00 (GMT+8)",
    whyChooseQingshun: "Hvorfor velge Qingshun",
    comparedToBrands: "sammenlignet med premium-merker",
    certifiedManufacturing: "sertifisert produksjon",
    yearsOfExperience: "års erfaring",
    globalExport: "Global eksportkapasitet",
    contactToday: "Kontakt oss i dag for et gratis tilbud!",
    costSavingsCompared: "50-70% kostnadsbesparelse sammenlignet med premium-merker",

    // Home Page - Missing Keys
    comprehensiveSolutions: "Omfattende løsninger for dine kontaktbehov",
    aboutOurCompany: "Om selskapet vårt",
    isoCertified: "ISO 9001 sertifisert",
    rohsCompliant: "RoHS-kompatibel",
    globalStandards: "Globale kvalitetsstandarder",
    compatibleWith: "Kompatibel med 20+ store merker",
    directReplacementsDesc: "Direkte erstatninger for premium-merker med betydelige kostnadsbesparelser",
    money: "Penger",
    contactUsToday: "Kontakt oss i dag for et gratis tilbud og se hvor mye du kan spare",

    // Products Page - Missing Keys
    connectorSolutions: "Kontaktløsninger",
    highSpeedData: "Høyhastighets dataoverføring",
    needCustomConnectorSolution: "Trenger du en tilpasset kontaktløsning?",

    // Services Page - Missing Keys
    ourServicesTitle: "Våre tjenester",
    service: "Tjeneste",
    ourProcessTitle: "Vår prosess",
    readyToStartProject: "Klar til å starte prosjektet ditt?",

    // Manufacturing Page - Missing Keys
    customPlastic: "Tilpasset plastisk kontakthusproduksjon",
    materialPA: "Materialer: PA66, PA6, PBT, LCP, PPS",
    tolerance: "Toleranse: ±0,05 mm presisjon",
    stampingWorkshop: "Termingsverksted",
    precisionCopper: "Presisjons kobberlegering terminal terming",
    materialBrass: "Materialer: Messing, Fosfor-bronse, Beryllium-kobber",
    thickness: "Tykkelsesområde: 0,1 mm - 3,0 mm",
    inHouseMold: "Intern formdesign og produksjon",
    cadcad: "CAD/CAM/CAE designkapasitet",
    moldMaintenance: "Formvedlikehold og reparasjon",
    cncMachining: "CNC-bearbeiding",
    highPrecision: "Høy-presisjons komponentbearbeiding",
    edm: "EDM (Elektrisk utladningsbearbeiding)",
    wireCutting: "Ledningskutting og profilbearbeiding",
    cncMilling: "CNC-fresing og -dreining",
    surfaceFinishing: "Overflatebehandling og polering",
    assemblyLines: "Monteringslinjer",
    automatedConnector: "Automatiserte kontaktmonteringssystemer",
    semiAutomatic: "Halvautomatiske monteringslinjer",
    fullyAutomatic: "Fullt automatiske produktionslinjer",
    inlineTesting: "Innebygd testing og kvalitetskontroll",
    cleanRoom: "Renrommonteringsmiljø",
    rohsCertified: "RoHS-sertifiserte kvalitetskontrollprosesser",
    incomingMaterial: "Innkommende materialinspeksjon",
    reliabilityTesting: "Miljø- og pålitelighetstesting",
    restrictionHazardous: "Begrensning av farlige stoffer",
    qualityManagement: "Kvalitetsstyringssystem",
    automotiveQuality: "Bilindustriens kvalitetsstyring",
    safetyCertification: "Sikkerhetssertifisering",
    designReview: "Designgjennomgang",
    analyzeTechnical: "Analysere tekniske krav og spesifikasjoner",
    createSamples: "Lage prøver for validering og testing",
    developMolds: "Utvikle former og produksjonsverktøy",
    massProduction: "Masseproduksjon med kvalitetskontroll",
    comprehensiveInspection: "Omfattende inspeksjon og testing",
    packagingShipping: "Profesjonell emballasje og frakt",
    manufacturingCapabilities: "Produksjonskapasiteter",
    inHouseProduction: "Intern produksjon",
    manufacturingDescription: "Komplette interne produksjonskapasiteter inkludert sprøytestøping, terming, CNC-bearbeiding og montering med streng kvalitetskontroll",
    completeInHouse: "Komplett intern produksjon fra design til levering",
    capabilities: "Kapasiteter",
    ourCoreCapabilities: "Våre kjernekapasiteter",
    stateOfTheArt: "Toppmoderne anlegg og utstyr for presisjonsproduksjon",
    facility: "Anlegg",
    ourManufacturingProcess: "Vår produksjonsprosess",
    industryCertifications: "Industrisertifiseringer",
    readyToStartManufacturingProject: "Klar til å starte produksjonsprosjektet ditt?",
    getInTouch: "Ta kontakt",
  }
};

export default translations;